(function () {
  "use strict";
  function getProductSizes() {
    var raw = window.__aloeSizes,
      values = [];
    if (Array.isArray(raw)) values = raw;
    else if (raw && Array.isArray(raw.value)) values = raw.value;
    else if (typeof raw == "string") {
      var decimalMarker = "\uE000";
      values = raw
        .replace(/(\d),(\d)(?=\s*(?:\(|,|$))/g, "$1" + decimalMarker + "$2")
        .split(/\s*(?:,|;|\n|\/\/)\s*/)
        .map(function (size) {
          return size.replace(new RegExp(decimalMarker, "g"), ",");
        });
    }
    var seen = {};
    values = values
      .map(function (size) {
        return String(size).trim();
      })
      .filter(function (size) {
        var key = size.toLowerCase();
        return !size || seen[key] ? !1 : ((seen[key] = !0), !0);
      });
    var standardSizeOrder = {
      xxxs: 0,
      "3xs": 0,
      xxs: 1,
      "2xs": 1,
      xs: 2,
      s: 3,
      m: 4,
      l: 5,
      xl: 6,
      xxl: 7,
      "2xl": 7,
      xxxl: 8,
      "3xl": 8,
      "4xl": 9,
      "5xl": 10,
      "6xl": 11,
      "7xl": 12,
      "8xl": 13,
    };
    return (
      values.length > 1 &&
        values.every(function (size) {
          return Object.prototype.hasOwnProperty.call(
            standardSizeOrder,
            size.toLowerCase(),
          );
        }) &&
        values.sort(function (a, b) {
          return (
            standardSizeOrder[a.toLowerCase()] -
            standardSizeOrder[b.toLowerCase()]
          );
        }),
      values
    );
  }
  var PRINT_WIDTH_CM = 28,
    designerParams = new URLSearchParams(window.location.search),
    upsellReturnTo = designerParams.get("return_to") || "/cart";
  (upsellReturnTo.charAt(0) !== "/" || upsellReturnTo.indexOf("//") === 0) &&
    (upsellReturnTo = "/cart");
  var UPSELL_FLOW = {
      active: !1,
      quantity: Math.max(
        5,
        parseInt(designerParams.get("aloe_upsell_quantity"), 10) || 5,
      ),
      returnTo: upsellReturnTo,
    },
    MOCKUP_CONFIG = {
      "tshirt-rundhals": {
        collections: [
          "t-shirt-rundhals",
          "t-shirt",
          "bestseller-t-shirts",
          "kinder-t-shirts",
          "arbeitsshirts",
        ],
      },
      longsleeve: {
        collections: [
          "longsleeve",
          "langarmshirts",
          "longsleeves",
          "langarm-shirts",
          "sweatshirts",
        ],
      },
      vneck: {
        collections: [
          "t-shirt-v-ausschnitt",
          "v-ausschnitt",
          "v-neck",
          "vneck",
          "t-shirt-v-neck",
        ],
      },
      polo: {
        collections: [
          "poloshirts",
          "polo-shirts",
          "polo",
          "kurzarm-polo",
          "poloshirts-kurzarm",
          "funkionspoloshirts",
          "kinder-poloshirts",
        ],
      },
      "polo-langarm": {
        collections: [
          "polo-langarm",
          "langarm-poloshirts",
          "langarm-polo",
          "poloshirts-langarm",
        ],
      },
      hoodie: {
        collections: [
          "hoodies",
          "pullover",
          "kapuzenpullover",
          "arbeitspullover",
        ],
      },
      zipper: {
        collections: [
          "zip-hoodies",
          "sweatjacken",
          "zipper",
          "reissverschluss-hoodies",
          "kapuzenjacken",
        ],
      },
      jacke: {
        collections: [
          "softshell-jacken",
          "fleecejacken",
          "arbeitsjacken",
          "jacken",
          "wetterschutzjacken",
          "softshelljacken",
          "winterjacken",
          "funktionsjacken-outdoor",
          "3-in-1-jacken",
        ],
      },
      "jacke-kapuze": {
        collections: [
          "regenjacken",
          "windjacken",
          "jacken-mit-kapuze",
          "hardshell-jacken",
        ],
      },
      weste: {
        collections: ["westen", "softshell-westen", "fleecewesten", "weste"],
      },
      hemd: {
        collections: [
          "hemden-kurzarm",
          "hemden-langarm",
          "trachtenhemden",
          "businesshemden",
          "blusen-kurzarm",
          "blusen-langarm",
        ],
      },
      tanktop: { collections: ["tanktops", "tank-tops", "muskelshirts"] },
      hose: {
        collections: [
          "hosen",
          "arbeitshosen",
          "cargohosen",
          "berufshosen",
          "jogginghosen",
        ],
      },
      latzhose: { collections: ["latzhosen", "arbeitslatzhose"] },
      shorts: {
        collections: ["shorts", "kurze-hosen", "sportshorts", "trikots-shorts"],
      },
      cap: {
        collections: ["baseball-caps", "flexfit-caps", "trucker-caps", "hute"],
      },
      snapback: { collections: ["snapback-caps"] },
      beanie: {
        collections: [
          "mutzen-beanies",
          "beanies",
          "mutzen",
          "wintermutzen",
          "strickmutzen",
          "schals",
        ],
      },
      handtuch: {
        collections: [
          "handtuch",
          "gastetuch",
          "duschtuch",
          "bade-saunatuch",
          "golftuch",
          "handtucher",
        ],
      },
      bademantel: { collections: ["bademantel", "frotteebademantel"] },
      schuerze: {
        collections: [
          "schurzen",
          "kuchenschurzen",
          "schurze",
          "kochschurze",
          "gastro-kleidung",
        ],
      },
      socken: { collections: ["socken", "arbeitssocken", "sportsocken"] },
    },
    COLOR_MAP = {
      weiß: "#f8f8f8",
      weiss: "#f8f8f8",
      white: "#f8f8f8",
      "off white": "#f5f0e8",
      "natural white": "#f0ece0",
      cream: "#fffdd0",
      ivory: "#fffff0",
      schwarz: "#1a1a1a",
      black: "#1a1a1a",
      "used black": "#2a2820",
      "jet black": "#0a0a0a",
      "deep black": "#111111",
      anthrazit: "#3a3a3a",
      anthracite: "#3a3a3a",
      charcoal: "#404040",
      "dark charcoal": "#333333",
      carbon: "#3c3c3c",
      dunkelgrau: "#555555",
      "dark grey": "#555555",
      "dark gray": "#555555",
      grau: "#888888",
      grey: "#888888",
      gray: "#888888",
      "medium grey": "#808080",
      "sport grey": "#9a9a9a",
      "sport gray": "#9a9a9a",
      "athletic heather": "#9090a0",
      "heather grey": "#999999",
      "heather gray": "#999999",
      "melange grey": "#aaaaaa",
      hellgrau: "#c8c8c8",
      "light grey": "#c8c8c8",
      "light gray": "#c8c8c8",
      "silver grey": "#b0b8c0",
      "marl grey": "#b0b0b0",
      navy: "#1a2a5e",
      marine: "#1a2a5e",
      dunkelblau: "#1a2a5e",
      "navy blue": "#1a2744",
      "french navy": "#152a4e",
      marineblau: "#1a2a5e",
      "dark navy": "#111e40",
      "light navy": "#334488",
      "royal navy": "#1a2060",
      königsblau: "#2255bb",
      royal: "#2040aa",
      "royal blue": "#2040aa",
      blau: "#2a6fdb",
      blue: "#2a6fdb",
      "cobalt blue": "#0050cc",
      himmelblau: "#55aadd",
      "sky blue": "#5ba3c9",
      "baby blue": "#89cff0",
      "carolina blue": "#5b9bd5",
      "electric blue": "#0050ee",
      sapphire: "#0f52ba",
      "diva blue": "#1a3a80",
      denim: "#1560bd",
      "steel blue": "#4682b4",
      "cornflower blue": "#6495ed",
      "dusty blue": "#6699aa",
      "ocean blue": "#0077b6",
      teal: "#008080",
      petrol: "#005577",
      petrolblau: "#005577",
      rot: "#cc2222",
      red: "#cc2222",
      "fire red": "#cc2200",
      "bright red": "#dd1111",
      "deep red": "#991111",
      "antique cherry red": "#8b2020",
      "cherry red": "#990022",
      bordeaux: "#7a1a2a",
      burgund: "#7a1a2a",
      burgundy: "#7a1a2a",
      wine: "#6b1f2a",
      "wine red": "#6b1f2a",
      "dark red": "#8b0000",
      cardinal: "#8b0018",
      cranberry: "#8b1a3a",
      maroon: "#800000",
      "brick red": "#b22222",
      tomato: "#cc3311",
      ruby: "#9b111e",
      koralle: "#e06050",
      coral: "#e06050",
      azalea: "#e87090",
      rosa: "#f0a0c0",
      pink: "#e060a0",
      "hot pink": "#ff69b4",
      "light pink": "#ffb6c1",
      "baby pink": "#f4c2c2",
      "ballet pink": "#e8b4b8",
      "flamingo pink": "#f7a1c4",
      "candy pink": "#e8789c",
      "orchid pink": "#da70d6",
      orchid: "#da70d6",
      "millennial pink": "#f0a0c0",
      "dusty pink": "#d4a0a8",
      blush: "#d4a0a8",
      "old rose": "#c08080",
      "antique pink": "#c08080",
      fuchsia: "#c0008a",
      magenta: "#cc00aa",
      orange: "#e05500",
      "bright orange": "#ff6600",
      "dark orange": "#cc4400",
      "tiger orange": "#e05000",
      tangerine: "#f28500",
      gelb: "#e8c000",
      yellow: "#e8c000",
      "solar yellow": "#f0d000",
      "bright yellow": "#ffe000",
      lemon: "#fff44f",
      "lemon yellow": "#fff44f",
      gold: "#c8a000",
      "golden yellow": "#d4a000",
      amber: "#ffbf00",
      grün: "#2d7a3a",
      green: "#2d7a3a",
      "bright green": "#00aa44",
      "kelly green": "#1a8a1a",
      "irish green": "#009900",
      "meadow green": "#32a852",
      "bottle green": "#1a4a2a",
      flaschengrün: "#1a4a2a",
      "dark green": "#1a3a20",
      "forest green": "#228b22",
      forest: "#228b22",
      "hunter green": "#355e3b",
      "racing green": "#1a3a1a",
      "military green": "#4a5a2a",
      "mint green": "#98ff98",
      mint: "#98ff98",
      sage: "#bcb88a",
      pistachio: "#80c060",
      "apple green": "#8db600",
      olive: "#6a6a2a",
      oliv: "#6a6a2a",
      "olive green": "#6b8e23",
      "khaki green": "#6b8e23",
      "orchid green": "#5a8a40",
      khaki: "#8a8040",
      "millennial khaki": "#baa070",
      "urban khaki": "#a08858",
      beige: "#d4c4a0",
      sand: "#d2b48c",
      natural: "#e8dcc8",
      cornsilk: "#f5e8c0",
      camel: "#c19a6b",
      tan: "#d2b48c",
      stone: "#c5b9a8",
      taupe: "#8b7d6b",
      desert: "#c2a27a",
      sahara: "#d4a96a",
      lila: "#7a3a9a",
      violett: "#7a3a9a",
      purple: "#7030a0",
      violet: "#7030a0",
      "radiant purple": "#7030a0",
      "urban purple": "#6020a0",
      "dark purple": "#4a1a7a",
      grape: "#6f2da8",
      plum: "#8b008b",
      lavender: "#b57edc",
      lavendel: "#b57edc",
      lilac: "#c8a2c8",
      "heather purple": "#9370db",
      mauve: "#b06090",
      türkis: "#2a9a8a",
      turquoise: "#2a9a8a",
      "real turquoise": "#008888",
      aqua: "#00cccc",
      cyan: "#00bbcc",
      "teal blue": "#008b8b",
      emerald: "#009b77",
      jade: "#00a86b",
      braun: "#7a4a2a",
      brown: "#7a4a2a",
      "dark brown": "#5c3317",
      chocolate: "#7b3f00",
      mocha: "#967259",
      caramel: "#c68642",
      terracotta: "#c0533a",
      rust: "#b7410e",
      copper: "#b87333",
      silber: "#a0a8b0",
      silver: "#a0a8b0",
      chrome: "#c0c0c0",
      apricot: "#f4a070",
      peach: "#ffcba4",
      indigo: "#3f0080",
      jeans: "#1560bd",
      camouflage: "#78866b",
      camo: "#78866b",
      army: "#4a5a2a",
      multicolour: "#888888",
      multicolor: "#888888",
      bunt: "#888888",
    },
    S = {
      product: null,
      variants: [],
      selectedColor: null,
      mockupType: null,
      hasFrontZipper: !1,
      renderToken: 0,
      mockupView: "front",
      logoSrc: null,
      logoOriginalSrc: null,
      logoFile: null,
      logoNatW: 0,
      logoNatH: 0,
      logoPosX: 52,
      logoPosY: 30,
      logoScale: 18,
      logoRotation: 0,
      logoFlipH: !1,
      viewLogos: {
        front: { posX: 52, posY: 38, scale: 18, rotation: 0, flipH: !1 },
        back: { posX: 52, posY: 38, scale: 18, rotation: 0, flipH: !1 },
        side: { posX: 52, posY: 38, scale: 18, rotation: 0, flipH: !1 },
        side_r: { posX: 52, posY: 38, scale: 18, rotation: 0, flipH: !1 },
      },
      dragging: !1,
      dragStartX: 0,
      dragStartY: 0,
      dragStartPosX: 0,
      dragStartPosY: 0,
    },
    MASK_CACHE = {},
    editHistory = [],
    editIndex = -1,
    editTimer,
    applyingEdit = !1;
  function sessionStatus(message) {
    var el = document.getElementById("des-session-status");
    el && (el.textContent = message);
  }
  function captureEdit() {
    saveViewLogo();
    var quantities = {};
    return (
      document.querySelectorAll(".des-size-qty").forEach(function (input) {
        quantities[input.dataset.size] = input.value;
      }),
      {
        productId: S.product.id,
        productTitle: S.product.title,
        productPath: location.pathname,
        savedAt: Date.now(),
        color: S.selectedColor,
        view: S.mockupView,
        views: JSON.parse(JSON.stringify(S.viewLogos)),
        src: S.logoSrc,
        original: S.logoOriginalSrc,
        file: S.logoFile,
        width: S.logoNatW,
        height: S.logoNatH,
        quantities: quantities,
        noSize: (document.getElementById("des-nosize-qty") || {}).value || "0",
        method: document.getElementById("des-method-select").value,
      }
    );
  }
  function editSignature(edit) {
    return JSON.stringify([
      edit.color,
      edit.views,
      edit.quantities,
      edit.noSize,
      edit.method,
    ]);
  }
  function recordEdit() {
    if (!(applyingEdit || !S.editorOpened || S.exporting)) {
      var next = captureEdit(),
        current = editHistory[editIndex];
      (current &&
        current.src === next.src &&
        current.file === next.file &&
        editSignature(current) === editSignature(next)) ||
        ((editHistory = editHistory.slice(0, editIndex + 1)),
        editHistory.push(next),
        editHistory.length > 40 && editHistory.shift(),
        (editIndex = editHistory.length - 1),
        updateHistoryButtons());
    }
  }
  function scheduleEdit() {
    applyingEdit ||
      (clearTimeout(editTimer), (editTimer = setTimeout(recordEdit, 350)));
  }
  function updateHistoryButtons() {
    ((document.getElementById("des-undo").disabled = editIndex < 1),
      (document.getElementById("des-redo").disabled =
        editIndex >= editHistory.length - 1));
  }
  function restoreEdit(edit) {
    ((applyingEdit = !0),
      clearTimeout(editTimer),
      (S.logoSrc = edit.src),
      (S.logoOriginalSrc = edit.original),
      (S.logoFile = edit.file),
      (S.logoNatW = edit.width),
      (S.logoNatH = edit.height),
      (S.viewLogos = JSON.parse(JSON.stringify(edit.views))),
      (S.mockupView = edit.view),
      (S.selectedColor = edit.color),
      document.querySelectorAll(".des-color").forEach(function (el) {
        el.classList.toggle("active", el.dataset.value === S.selectedColor);
      }),
      (document.getElementById("des-color-label").textContent =
        displayColorName(S.selectedColor || "")),
      document.querySelectorAll(".des-mt-wrap").forEach(function (el) {
        el.classList.toggle("active", el.dataset.view === S.mockupView);
      }),
      document.querySelectorAll(".des-size-qty").forEach(function (el) {
        el.value = Math.max(
          0,
          parseInt(edit.quantities[el.dataset.size], 10) || 0,
        );
      }),
      (document.getElementById("des-method-select").value = edit.method));
    var noSize = document.getElementById("des-nosize-qty");
    noSize && (noSize.value = Math.max(0, parseInt(edit.noSize, 10) || 0));
    var logo = document.getElementById("des-logo-overlay"),
      thumb = document.getElementById("des-logo-thumb");
    (edit.src
      ? ((logo.src = edit.src), (thumb.src = edit.src))
      : (logo.removeAttribute("src"), thumb.removeAttribute("src")),
      thumb.classList.toggle("visible", !!edit.src),
      document
        .getElementById("des-upload-btn")
        .classList.toggle("has-logo", !!edit.src),
      document
        .getElementById("des-logo-edit-actions")
        .classList.toggle("visible", !!edit.src),
      (document.getElementById("des-restore-logo").disabled =
        edit.src === edit.original),
      (document.getElementById("des-drop-hint").style.display = edit.src
        ? "none"
        : ""),
      S.mockupType ? renderMockup() : updateVariantImage(),
      loadViewLogo(S.mockupView),
      updateThumbBadges(),
      updateSummary(),
      (applyingEdit = !1),
      updateHistoryButtons());
  }
  function draftStore(mode, value) {
    return new Promise(function (resolve, reject) {
      if (!window.indexedDB)
        return reject(
          new Error("Dieser Browser erlaubt keine lokale Speicherung."),
        );
      var request = indexedDB.open("aloe-designer-drafts", 1);
      ((request.onupgradeneeded = function () {
        request.result.createObjectStore("drafts", { keyPath: "productId" });
      }),
        (request.onerror = function () {
          reject(new Error("Der Browserspeicher ist nicht verf\xFCgbar."));
        }),
        (request.onsuccess = function () {
          var db = request.result,
            transaction = db.transaction(
              "drafts",
              mode === "save" ? "readwrite" : "readonly",
            ),
            store = transaction.objectStore("drafts"),
            operation =
              mode === "save"
                ? store.put(value)
                : store.get(mode === "logo" ? "__last_logo__" : S.product.id);
          (mode === "save" &&
            value.file &&
            value.src &&
            store.put(Object.assign({}, value, { productId: "__last_logo__" })),
            (transaction.oncomplete = function () {
              (db.close(), resolve(operation.result));
            }),
            (transaction.onerror = transaction.onabort =
              function () {
                (db.close(),
                  reject(
                    new Error(
                      "Entwurf konnte nicht gespeichert oder gelesen werden.",
                    ),
                  ));
              }));
        }));
    });
  }
  function bindEditorImprovements() {
    var overlay = document.getElementById("aloe-designer-overlay"),
      compact = window.matchMedia("(max-width: 749px)");
    function setToolsLayout() {
      document
        .querySelectorAll(".des-tools-details,.des-edit-details")
        .forEach(function (el) {
          el.open = el.classList.contains("des-edit-details") && !!S.logoSrc && !compact.matches;
        });
    }
    var modal = document.getElementById("aloe-designer-modal");
    var title = modal.querySelector(".des-header-title");
    title.id = "des-dialog-title";
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    modal.setAttribute("aria-labelledby", title.id);
    modal.tabIndex = -1;
    overlay.inert = true;
    var tools = modal.querySelector(".des-tools-details");
    var help = document.getElementById("des-help-btn");
    help.parentNode.insertBefore(tools, help);
    modal.querySelectorAll(".des-size-qty").forEach(function (input, index) {
      var label = input.parentNode.querySelector(".des-size-label");
      label.id = "des-size-label-" + index;
      input.setAttribute("aria-labelledby", label.id);
      input.step = "1";
      input.inputMode = "numeric";
    });
    var noSize = document.getElementById("des-nosize-qty");
    if (noSize) { noSize.step = "1"; noSize.inputMode = "numeric"; }
    var method = document.getElementById("des-method-select");
    var methodLabel = method.closest(".des-section").querySelector(".des-section-title");
    methodLabel.id = "des-method-label";
    method.setAttribute("aria-labelledby", methodLabel.id);
    document.getElementById("des-summary-box").setAttribute("role", "status");
    modal.querySelectorAll(".des-mt-wrap,.des-thumb").forEach(function (view) {
      view.setAttribute("role", "button");
      view.tabIndex = 0;
      view.setAttribute("aria-label", view.textContent.trim() || view.alt);
      view.addEventListener("keydown", function (event) {
        if (event.key === " " || event.key === "Enter") {
          event.preventDefault(); event.stopPropagation(); view.click();
        }
      });
    });
    function syncPressedStates() {
      modal.querySelectorAll(".des-color,.des-mt-wrap,.des-thumb").forEach(function (control) {
        control.setAttribute("aria-pressed", String(control.classList.contains("active")));
      });
    }
    overlay.addEventListener("click", syncPressedStates);
    syncPressedStates();
    overlay.addEventListener("keydown", function (event) {
      if (event.key !== "Tab" || !overlay.classList.contains("active")) return;
      var controls = Array.from(modal.querySelectorAll('a[href],button,input,select,summary,[tabindex="0"]')).filter(function (control) {
        return !control.disabled && !control.closest("[inert]") && control.getClientRects().length && getComputedStyle(control).visibility !== "hidden";
      });
      var first = controls[0], last = controls[controls.length - 1];
      if (!first) { event.preventDefault(); modal.focus(); return; }
      if (event.shiftKey && (document.activeElement === first || document.activeElement === modal)) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      }
    });
    (setToolsLayout(),
      compact.addEventListener("change", setToolsLayout),
      ["click", "change", "input", "pointerup", "keyup"].forEach(
        function (name) {
          overlay.addEventListener(name, function (event) {
            event.target.closest(
              "#des-undo,#des-redo,#des-draft-load,#des-draft-save",
            ) || scheduleEdit();
          });
        },
      ),
      (document.getElementById("des-undo").onclick = function () {
        (clearTimeout(editTimer),
          recordEdit(),
          editIndex > 0 && restoreEdit(editHistory[--editIndex]));
      }),
      (document.getElementById("des-redo").onclick = function () {
        (clearTimeout(editTimer),
          editIndex < editHistory.length - 1 &&
            restoreEdit(editHistory[++editIndex]));
      }),
      (document.getElementById("des-draft-save").onclick = function () {
        var button = this;
        ((button.disabled = !0),
          draftStore("save", captureEdit())
            .then(function () {
              sessionStatus(
                "Entwurf mit Originaldatei in diesem Browser gespeichert.",
              );
            })
            .catch(function (error) {
              sessionStatus(error.message);
            })
            .finally(function () {
              button.disabled = !1;
            }));
      }),
      (document.getElementById("des-draft-load").onclick = function () {
        var button = this;
        ((button.disabled = !0),
          draftStore("load")
            .then(function (edit) {
              if (!edit) {
                sessionStatus(
                  "F\xFCr dieses Produkt ist hier noch kein Entwurf gespeichert.",
                );
                return;
              }
              var colors = Array.from(
                document.querySelectorAll(".des-color"),
              ).map(function (el) {
                return el.dataset.value;
              });
              if (colors.length && colors.indexOf(edit.color) < 0)
                throw new Error(
                  "Die gespeicherte Farbe ist nicht mehr verf\xFCgbar. Bitte neu ausw\xE4hlen.",
                );
              (recordEdit(),
                restoreEdit(edit),
                recordEdit(),
                sessionStatus(
                  "Entwurf geladen. Bitte verf\xFCgbare Gr\xF6\xDFen und St\xFCckzahlen vor dem Absenden pr\xFCfen.",
                ));
            })
            .catch(function (error) {
              sessionStatus(error.message);
            })
            .finally(function () {
              button.disabled = !1;
            }));
      }),
      (document.getElementById("des-reuse-logo").onclick = function () {
        draftStore("logo")
          .then(function (saved) {
            if (!saved || !saved.file) {
              sessionStatus(
                "Speichere zuerst einen Entwurf mit Logo. Danach kannst du das Logo hier \xFCbernehmen.",
              );
              return;
            }
            recordEdit();
            var edit = captureEdit();
            ((edit.src = saved.src),
              (edit.original = saved.original),
              (edit.file = saved.file),
              (edit.width = saved.width),
              (edit.height = saved.height),
              restoreEdit(edit),
              placeLogoOnCurrentView(),
              recordEdit(),
              sessionStatus(
                "Logo \xFCbernommen. Bitte die Position auf diesem Textil festlegen.",
              ));
          })
          .catch(function (error) {
            sessionStatus(error.message);
          });
      }),
      (document.getElementById("des-sheet-download").onclick = function () {
        if (!S.logoSrc || S.saving || S.exporting) {
          sessionStatus("Bitte zuerst ein Logo auf dem Textil platzieren.");
          return;
        }
        createDesignerPreviewFile(
          "ALOE-" + Date.now().toString(36).toUpperCase(),
        )
          .then(function (file) {
            var url = URL.createObjectURL(file),
              link = document.createElement("a");
            ((link.href = url),
              (link.download = file.name),
              link.click(),
              setTimeout(function () {
                URL.revokeObjectURL(url);
              }, 1e4));
          })
          .catch(function (error) {
            sessionStatus(error.message);
          });
      }),
      (document.getElementById("des-placement").onchange = function () {
        if (!(!S.logoSrc || !this.value)) {
          if (
            this.value !== "middle" &&
            (S.mockupView !== "front" ||
              !/^(tshirt-rundhals|vneck|polo|polo-langarm|hoodie|zipper|longsleeve|hemd|jacke|jacke-kapuze|weste|tanktop)$/.test(
                S.mockupType || "",
              ))
          ) {
            (sessionStatus(
              "Brustpositionen sind nur f\xFCr die Vorderseite von Oberteilen vorgesehen.",
            ),
              (this.value = ""));
            return;
          }
          (S.viewLogos[S.mockupView].active || placeLogoOnCurrentView(),
            (S.logoPosX =
              this.value === "left" ? 62 : this.value === "right" ? 38 : 50),
            (S.logoPosY = this.value === "middle" ? 45 : 34),
            this.value !== "middle" && (S.logoScale = 12),
            applyLogoTransform(),
            saveViewLogo(),
            (this.value = ""));
        }
      }));
  }
  function esc(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }
  function valTitle(v) {
    return v
      ? typeof v == "string"
        ? v
        : String(v.title || v.name || v.value || v.label || "")
      : "";
  }
  function displayColorName(value) {
    return value === "Sunste Orange" ? "Sunset Orange" : value;
  }
  function readSwatchesFromDOM() {
    var sw = window.__aloeSwatches || {};
    function addColor(name, colorStr) {
      if (!(!name || !colorStr)) {
        var key = name.toLowerCase().trim();
        if (!(!key || sw[key])) {
          var clean = colorStr.replace(/\s+/g, " ").trim();
          clean &&
            clean !== "transparent" &&
            clean !== "rgba(0, 0, 0, 0)" &&
            (sw[key] = clean);
        }
      }
    }
    function getCssVar(el, varName) {
      return getComputedStyle(el).getPropertyValue(varName).trim();
    }
    (document
      .querySelectorAll('.swatch, [class*="swatch"]')
      .forEach(function (el) {
        var bg = getCssVar(el, "--swatch--background");
        if (
          (bg || (bg = el.style.background || el.style.backgroundColor || ""),
          !!bg)
        ) {
          var inp =
              el.querySelector('input[type="radio"]') ||
              (el.closest("label") &&
                el.closest("label").querySelector("input")),
            name =
              (inp && (inp.value || inp.getAttribute("data-option-value"))) ||
              el.getAttribute("data-value") ||
              el.getAttribute("value") ||
              el.getAttribute("title") ||
              el.getAttribute("aria-label") ||
              (el.textContent || "").trim();
          addColor(name, bg);
        }
      }),
      document.querySelectorAll(".up-option-value-d5").forEach(function (el) {
        var name =
            el.getAttribute("value") ||
            (el.querySelector("span") &&
              el.querySelector("span").textContent) ||
            "",
          bg = el.style.background || el.style.backgroundColor || "";
        addColor(name, bg);
      }),
      document
        .querySelectorAll(
          'input[type="radio"][name*="olor"], input[type="radio"][name*="arbe"]',
        )
        .forEach(function (inp) {
          var lbl = document.querySelector('label[for="' + inp.id + '"]'),
            bg = "";
          if (lbl) {
            bg =
              getCssVar(lbl, "--swatch--background") ||
              lbl.style.background ||
              lbl.style.backgroundColor ||
              "";
            var swEl = lbl.querySelector(".swatch");
            !bg &&
              swEl &&
              (bg =
                getCssVar(swEl, "--swatch--background") ||
                swEl.style.background ||
                "");
          }
          bg && addColor(inp.value, bg);
        }),
      document
        .querySelectorAll("[data-option-value-swatch]")
        .forEach(function (el) {
          var name =
              el.getAttribute("data-option-value") || el.textContent.trim(),
            bg =
              getCssVar(el, "--swatch--background") ||
              el.style.background ||
              "";
          addColor(name, bg);
        }),
      (window.__aloeSwatches = sw));
  }
  var COLOR_PICKER_OPT_NAME = "";
  function hideColorDropdowns(root) {
    root = root || document;
    var sel = root.querySelector(
      'select[name="options[' + COLOR_PICKER_OPT_NAME + ']"]',
    );
    if (sel) {
      var wrap =
        sel.closest(".product-form__input--dropdown") || sel.parentElement;
      wrap.classList.add("aloe-replaced");
    }
  }
  function syncPickerSelection(picker, activeValue, checkSvg) {
    if (picker) {
      picker.querySelectorAll(".aloe-cp-swatch").forEach(function (s) {
        var isActive = s.getAttribute("data-value") === activeValue;
        (s.classList.toggle("is-active", isActive),
          (s.innerHTML = isActive ? checkSvg : ""));
      });
      var nameEl = picker.querySelector(".aloe-color-picker__selected");
      nameEl && (nameEl.textContent = activeValue);
    }
  }
  function buildColorSwatches() {
    var colorOpt = getColorOption();
    if (!(!colorOpt || !colorOpt.values || !colorOpt.values.length)) {
      COLOR_PICKER_OPT_NAME = (colorOpt.name || "").trim();
      var colorSelect = document.querySelector(
        'select[name="options[' + COLOR_PICKER_OPT_NAME + ']"]',
      );
      if (!colorSelect) {
        var firstVal = valTitle(colorOpt.values[0]);
        document
          .querySelectorAll("select.select__select")
          .forEach(function (sel) {
            if (
              !colorSelect &&
              Array.from(sel.options).some(function (o) {
                return o.value === firstVal;
              })
            ) {
              colorSelect = sel;
              var m = (sel.name || "").match(/options\[(.+)\]/);
              m && (COLOR_PICKER_OPT_NAME = m[1]);
            }
          });
      }
      if (colorSelect) {
        var variantSelects =
            colorSelect.closest("variant-selects") ||
            document.querySelector("variant-selects"),
          old = document.querySelector(".aloe-color-picker");
        (old && old.remove(), hideColorDropdowns());
        var checkSvg =
            '<svg class="aloe-cp-swatch__check" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3.5" style="filter:drop-shadow(0 0 2px rgba(0,0,0,0.5))"><polyline points="20 6 9 17 4 12"/></svg>',
          currentValue = colorSelect.value || valTitle(colorOpt.values[0]),
          picker = document.createElement("div");
        picker.className = "aloe-color-picker";
        var labelEl = document.createElement("div");
        ((labelEl.className = "aloe-color-picker__label"),
          (labelEl.innerHTML =
            "<span>" +
            esc(COLOR_PICKER_OPT_NAME) +
            ':</span><span class="aloe-color-picker__selected">' +
            esc(currentValue) +
            "</span>"),
          picker.appendChild(labelEl));
        var swatchGrid = document.createElement("div");
        if (
          ((swatchGrid.className = "aloe-color-picker__swatches"),
          colorOpt.values.forEach(function (v) {
            var vt = valTitle(v),
              colorHex = colorFromName(vt),
              rgb = hexToRgb(colorHex),
              isLight = rgb.r * 0.299 + rgb.g * 0.587 + rgb.b * 0.114 > 200,
              isSelected = currentValue === vt,
              btn = document.createElement("button");
            ((btn.type = "button"),
              (btn.className =
                "aloe-cp-swatch" + (isSelected ? " is-active" : "")),
              btn.setAttribute("data-value", vt),
              btn.setAttribute("title", vt),
              btn.setAttribute("aria-label", vt),
              btn.setAttribute("data-light", isLight ? "1" : "0"),
              (btn.style.background = colorHex),
              (btn.innerHTML = isSelected ? checkSvg : ""),
              btn.addEventListener("click", function () {
                var freshSelect = document.querySelector(
                  'select[name="options[' + COLOR_PICKER_OPT_NAME + ']"]',
                );
                freshSelect &&
                  (syncPickerSelection(picker, vt, checkSvg),
                  (S.selectedColor = vt),
                  (freshSelect.value = vt),
                  freshSelect.dispatchEvent(
                    new Event("change", { bubbles: !0 }),
                  ));
              }),
              swatchGrid.appendChild(btn));
          }),
          picker.appendChild(swatchGrid),
          variantSelects && variantSelects.parentElement)
        )
          variantSelects.parentElement.insertBefore(picker, variantSelects);
        else {
          var dropdownWrap =
            colorSelect.closest(".product-form__input--dropdown") ||
            colorSelect.parentElement;
          dropdownWrap.parentElement.insertBefore(picker, dropdownWrap);
        }
        if (
          variantSelects &&
          variantSelects.parentElement &&
          window.MutationObserver
        ) {
          var obs = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
              m.addedNodes.forEach(function (node) {
                if (node.tagName) {
                  var tag = node.tagName.toLowerCase(),
                    isVariantSelects = tag === "variant-selects",
                    containsVariantSelects =
                      !isVariantSelects &&
                      node.querySelector &&
                      node.querySelector("variant-selects");
                  if (!(!isVariantSelects && !containsVariantSelects)) {
                    hideColorDropdowns(
                      isVariantSelects
                        ? node
                        : node.querySelector("variant-selects"),
                    );
                    var newSel = document.querySelector(
                      'select[name="options[' + COLOR_PICKER_OPT_NAME + ']"]',
                    );
                    newSel &&
                      syncPickerSelection(picker, newSel.value, checkSvg);
                  }
                }
              });
            });
          });
          obs.observe(variantSelects.parentElement, {
            childList: !0,
            subtree: !1,
          });
        }
      }
    }
  }
  function syncSizePicker(picker, activeValue) {
    if (picker) {
      picker.querySelectorAll(".aloe-sz-btn").forEach(function (b) {
        b.classList.toggle(
          "is-active",
          b.getAttribute("data-value") === activeValue,
        );
      });
      var nameEl = picker.querySelector(".aloe-size-picker__selected");
      nameEl && (nameEl.textContent = activeValue);
    }
  }
  function buildSizeButtons() {
    var colorOptName = (COLOR_PICKER_OPT_NAME || "").toLowerCase();
    document
      .querySelectorAll(".product-form__input--dropdown")
      .forEach(function (dropWrap) {
        if (!dropWrap.classList.contains("aloe-replaced")) {
          var sizeSelect = dropWrap.querySelector("select");
          if (sizeSelect) {
            var nameAttr = sizeSelect.getAttribute("name") || "",
              m = nameAttr.match(/^options\[(.+)\]$/);
            if (m) {
              var oName = m[1],
                oLower = oName.toLowerCase();
              if (
                !(
                  oLower === colorOptName ||
                  oLower.indexOf("farbe") !== -1 ||
                  oLower.indexOf("color") !== -1 ||
                  oLower.indexOf("colour") !== -1
                )
              ) {
                var values = [];
                if (
                  (Array.from(sizeSelect.options).forEach(function (o) {
                    o.value &&
                      values.push({ value: o.value, disabled: o.disabled });
                  }),
                  !!values.length)
                ) {
                  dropWrap.classList.add("aloe-replaced");
                  var currentValue = sizeSelect.value || values[0].value,
                    picker = document.createElement("div");
                  ((picker.className = "aloe-size-picker"),
                    picker.setAttribute("data-opt", oName),
                    picker.setAttribute("data-sel-name", nameAttr));
                  var labelEl = document.createElement("div");
                  ((labelEl.className = "aloe-size-picker__label"),
                    (labelEl.innerHTML =
                      "<span>" +
                      esc(oName) +
                      ':</span><span class="aloe-size-picker__selected">' +
                      esc(currentValue) +
                      "</span>"),
                    picker.appendChild(labelEl));
                  var btnRow = document.createElement("div");
                  ((btnRow.className = "aloe-size-picker__buttons"),
                    values.forEach(function (item) {
                      var vt = item.value,
                        isSelected = currentValue === vt,
                        isUnavailable = item.disabled,
                        btn = document.createElement("button");
                      ((btn.type = "button"),
                        (btn.className =
                          "aloe-sz-btn" +
                          (isSelected ? " is-active" : "") +
                          (isUnavailable ? " is-unavailable" : "")),
                        btn.setAttribute("data-value", vt),
                        btn.setAttribute("title", vt),
                        (btn.textContent = vt),
                        btn.addEventListener("click", function () {
                          if (!isUnavailable) {
                            var freshSel = document.querySelector(
                              'select[name="' +
                                nameAttr.replace(/"/g, '\\"') +
                                '"]',
                            );
                            (freshSel ||
                              document
                                .querySelectorAll("select")
                                .forEach(function (s) {
                                  s.getAttribute("name") === nameAttr &&
                                    (freshSel = s);
                                }),
                              freshSel &&
                                (syncSizePicker(picker, vt),
                                (freshSel.value = vt),
                                freshSel.dispatchEvent(
                                  new Event("change", { bubbles: !0 }),
                                )));
                          }
                        }),
                        btnRow.appendChild(btn));
                    }),
                    picker.appendChild(btnRow));
                  var vsAncestor = dropWrap.closest("variant-selects");
                  if (
                    (vsAncestor && vsAncestor.parentElement
                      ? vsAncestor.parentElement.insertBefore(
                          picker,
                          vsAncestor,
                        )
                      : dropWrap.parentElement.insertBefore(picker, dropWrap),
                    window.MutationObserver)
                  ) {
                    var obsAttr = new MutationObserver(function () {
                      dropWrap.classList.contains("aloe-replaced") ||
                        dropWrap.classList.add("aloe-replaced");
                    });
                    obsAttr.observe(dropWrap, {
                      attributes: !0,
                      attributeFilter: ["class", "style"],
                    });
                    var vsParent = dropWrap.closest("variant-selects");
                    if (vsParent && vsParent.parentElement) {
                      var obsParent = new MutationObserver(function (
                        mutations,
                      ) {
                        mutations.forEach(function (mu) {
                          mu.addedNodes.forEach(function (node) {
                            node.querySelectorAll &&
                              node
                                .querySelectorAll("select")
                                .forEach(function (newSel) {
                                  if (
                                    newSel.getAttribute("name") === nameAttr
                                  ) {
                                    var newWrap =
                                      newSel.closest(
                                        ".product-form__input--dropdown",
                                      ) || newSel.parentElement;
                                    (newWrap.classList.add("aloe-replaced"),
                                      syncSizePicker(picker, newSel.value));
                                  }
                                });
                          });
                        });
                      });
                      obsParent.observe(vsParent.parentElement, {
                        childList: !0,
                        subtree: !0,
                      });
                    }
                  }
                }
              }
            }
          }
        }
      });
  }
  function colorFromName(name) {
    var nameStr = valTitle(name);
    if (!nameStr) return "#888888";
    var l = nameStr.toLowerCase().trim();
    if (!l) return "#888888";
    var sw = window.__aloeSwatches || {};
    if (sw[l]) return sw[l];
    if (COLOR_MAP[l]) return COLOR_MAP[l];
    for (var k in sw)
      if (
        k.length >= 3 &&
        (l === k || l.indexOf(k) !== -1 || k.indexOf(l) !== -1)
      )
        return sw[k];
    for (var k in COLOR_MAP)
      if (k.length >= 3 && l.indexOf(k) !== -1) return COLOR_MAP[k];
    return "#888888";
  }
  function hexToRgb(hex) {
    if (!hex) return { r: 128, g: 128, b: 128 };
    var m;
    return (m = hex.match(/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i))
      ? { r: +m[1], g: +m[2], b: +m[3] }
      : ((hex = hex.replace("#", "")),
        hex.length === 3 &&
          (hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]),
        {
          r: parseInt(hex.slice(0, 2), 16),
          g: parseInt(hex.slice(2, 4), 16),
          b: parseInt(hex.slice(4, 6), 16),
        });
  }
  function getColorOption() {
    var opts = (S.product && S.product.options_with_values) || [];
    if (!opts.length) {
      var names = (S.product && S.product.options) || [],
        colorIdx = -1;
      if (
        (names.forEach(function (n, i) {
          var l = (n || "").toLowerCase();
          (l.indexOf("farbe") !== -1 ||
            l.indexOf("color") !== -1 ||
            l.indexOf("colour") !== -1) &&
            (colorIdx = i);
        }),
        colorIdx === -1 && names.length && (colorIdx = 0),
        colorIdx === -1)
      )
        return null;
      var seen = {},
        values = [];
      return (
        (S.variants || []).forEach(function (v) {
          if (v.available !== !1) {
            var val = v["option" + (colorIdx + 1)];
            val && !seen[val] && ((seen[val] = !0), values.push(val));
          }
        }),
        { name: names[colorIdx], values: values }
      );
    }
    var found =
      opts.find(function (o) {
        var l = (o.name || "").toLowerCase();
        return (
          l.indexOf("farbe") !== -1 ||
          l.indexOf("color") !== -1 ||
          l.indexOf("colour") !== -1
        );
      }) || null;
    if (!found) return null;
    var colorIndex = opts.indexOf(found),
      available = {};
    (S.variants || []).forEach(function (variant) {
      if (variant.available !== !1) {
        var value =
          variant["option" + (colorIndex + 1)] ||
          (variant.options && variant.options[colorIndex]);
        value && (available[String(value)] = !0);
      }
    });
    var declared = (found.values || []).map(valTitle).filter(Boolean),
      filtered = declared.filter(function (value) {
        return available[value];
      });
    return { name: found.name, values: filtered.length ? filtered : declared };
  }
  function getColorOptionIndex() {
    var opts =
        (S.product && S.product.options_with_values) ||
        (S.product && S.product.options) ||
        [],
      colorOpt = getColorOption();
    if (!colorOpt) return 0;
    for (var i = 0; i < opts.length; i++) {
      var name = opts[i].name || opts[i];
      if (name === colorOpt.name) return i;
    }
    return 0;
  }
  function getCurrentPageColor() {
    var input = document.querySelector(
      'form[action="/cart/add"] [name="id"], .product-form [name="id"], input[name="id"]',
    );
    if (!input) return null;
    var variantId = parseInt(input.value, 10);
    if (!variantId) return null;
    var variant = S.variants.find(function (v) {
      return v.id === variantId;
    });
    if (!variant) return null;
    var idx = getColorOptionIndex();
    return variant["option" + (idx + 1)] || null;
  }
  function getSizeOptionIndex() {
    for (
      var opts =
          (S.product && S.product.options_with_values) ||
          (S.product && S.product.options) ||
          [],
        i = 0;
      i < opts.length;
      i++
    ) {
      var name = String(opts[i].name || opts[i] || "").toLowerCase();
      if (
        name.indexOf("gr\xF6\xDFe") !== -1 ||
        name.indexOf("groesse") !== -1 ||
        name.indexOf("size") !== -1
      )
        return i;
    }
    return -1;
  }
  function findVariant(color, size) {
    var colorIdx = getColorOptionIndex(),
      sizeIdx = getSizeOptionIndex();
    return (
      S.variants.find(function (v) {
        var opts =
            v.options || [v.option1, v.option2, v.option3].filter(Boolean),
          colorMatches = !color || opts[colorIdx] === color,
          sizeMatches = !size || sizeIdx < 0 || opts[sizeIdx] === size;
        return colorMatches && sizeMatches && v.available !== !1;
      }) ||
      S.variants.find(function (v) {
        var opts =
          v.options || [v.option1, v.option2, v.option3].filter(Boolean);
        return (
          (!color || opts[colorIdx] === color) &&
          (!size || sizeIdx < 0 || opts[sizeIdx] === size)
        );
      }) ||
      S.variants[0] ||
      null
    );
  }
  function getProductSearchText() {
    var handles = (S.product && S.product.collection_handles) || [];
    return [
      S.product && S.product.title,
      S.product && S.product.type,
      S.product && S.product.vendor,
      S.product && Array.isArray(S.product.tags)
        ? S.product.tags.join(" ")
        : "",
      handles.join(" "),
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
  }
  function getProductTitleText() {
    return [S.product && S.product.title, S.product && S.product.handle]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
  }
  function detectFrontZipper() {
    var titleText = getProductTitleText();
    return /(half[- ]?zip|1\/4[- ]?zip|quarter[- ]?zip)/.test(titleText)
      ? !1
      : /(full[- ]?zip|durchgehend(?:er|em|en)?\s+(?:rv|rei.ssverschluss)|zip.?hood|hoodie.*zip|sweatjacke|kapuzenjacke|zipp?[- ]?sweat|softshell(?:jacke| jacket)|fleecejacke|arbeitsjacke|regenjacke|winterjacke|windjacke|bodywarmer|weste)/.test(
          titleText,
        );
  }
  function detectMockupType() {
    var handles = (S.product && S.product.collection_handles) || [],
      titleText = getProductTitleText(),
      productText = getProductSearchText(),
      productType = String((S.product && S.product.type) || "").toLowerCase();
    if (
      /(g.rtel|hosentr.ger|knieschoner|taschen|rucks.cke|overall)/.test(
        productType,
      )
    )
      return null;
    if (/(westen|bodywarmer)/.test(productType)) return "weste";
    if (/(hemden|blusen)/.test(productType)) return "hemd";
    for (
      var titleRules = [
          ["vneck", /v[- ]?(neck|ausschnitt)/],
          ["polo-langarm", /(langarm.*polo|polo.*langarm)/],
          ["jacke-kapuze", /(regenjacke|windjacke|hardshell)/],
          ["weste", /(weste|bodywarmer|waistcoat|(^|\s)vest($|\s))/],
          [
            "zipper",
            /(full[- ]?zip|zip.?hood|hoodie.*zip|sweatjacke|kapuzenjacke|zipp?[- ]?sweat)/,
          ],
          [
            "jacke",
            /(arbeitsjacke|winterjacke|softshell(?:jacke| jacket)|fleecejacke|funktionsjacke|outdoorjacke)/,
          ],
          ["bademantel", /bademantel/],
          [
            "handtuch",
            /(handtuch|duschtuch|saunatuch|g.stetuch|golftuch|towel|washcloth)/,
          ],
          ["latzhose", /latzhose/],
          [
            "shorts",
            /(^|\s)(shorts|kurze[- ]?hose|bermuda|3\/4[- ]?(?:lauf)?hose)/,
          ],
          [
            "hose",
            /(^|\s)(hose|hosen|trousers?|pants?|sweatpants?|lauf(?:tight|hose))/,
          ],
          ["beanie", /(beanie|m.tze)/],
          ["snapback", /snapback/],
          ["cap", /(^|\s)(cap|caps|trucker|bucket hat)/],
          ["tanktop", /(tanktop|tank top|muskelshirt|singlet)/],
          ["schuerze", /(sch.rze|apron)/],
          ["socken", /(socke|socks|stutzenstrumpf)/],
          [
            "hoodie",
            /(hoodie|hoody|hooded sweat|kapuzenpullover|kapuzensweat)/,
          ],
          ["polo", /polo/],
          ["hemd", /(hemd|bluse)/],
          [
            "longsleeve",
            /(longsleeve|langarmshirt|long sleeve|sweatshirt|crewneck sweat|crew neck sweat|trainingstop|training top|pullover|sweater|fleece troyer)/,
          ],
          [
            "longsleeve",
            /(trikot.*(?:langarm|\bla\b)|(?:langarm|\bla\b).*trikot)/,
          ],
          [
            "tshirt-rundhals",
            /(trikot|jersey|funktionsshirt|function shirt|sport shirt|basketball.*top)/,
          ],
          ["tshirt-rundhals", /(t[- ]?shirt|rundhals|crew neck)/],
        ],
        r = 0;
      r < titleRules.length;
      r++
    )
      if (titleRules[r][1].test(titleText)) return titleRules[r][0];
    for (var key in MOCKUP_CONFIG)
      for (
        var colls = MOCKUP_CONFIG[key].collections, i = 0;
        i < colls.length;
        i++
      )
        if (handles.indexOf(colls[i]) !== -1) return key;
    for (
      var typeRules = [
          ["weste", /(westen|bodywarmer)/],
          ["jacke", /jacken/],
          ["hemd", /(hemden|blusen)/],
          ["schuerze", /sch.rzen/],
          ["handtuch", /(handt.cher|frottierwaren)/],
          ["beanie", /m.tzen/],
          ["cap", /(caps|h.te)/],
          ["polo", /(poloshirts|polos)/],
          ["longsleeve", /(sweatshirts|pullover)/],
          ["tshirt-rundhals", /(t-shirts|trikots|funktion)/],
          ["hose", /hosen/],
        ],
        t = 0;
      t < typeRules.length;
      t++
    )
      if (typeRules[t][1].test(productText)) return typeRules[t][0];
    return null;
  }
  function getMockupUrls(type) {
    return (window.__aloeMockups && window.__aloeMockups[type]) || null;
  }
  function loadMaskImage(url, cb) {
    if (
      MASK_CACHE[url] &&
      MASK_CACHE[url].complete &&
      MASK_CACHE[url].naturalWidth
    ) {
      cb(MASK_CACHE[url]);
      return;
    }
    var img = new Image();
    ((img.crossOrigin = "anonymous"),
      (img.onload = function () {
        ((MASK_CACHE[url] = img), cb(img));
      }),
      (img.onerror = function () {
        console.warn("[Aloe Mockup] Konnte nicht laden:", url);
      }),
      (img.src = url));
  }
  function colorizeImage(img, colorHex) {
    var w = img.naturalWidth || img.width,
      h = img.naturalHeight || img.height;
    if (!w || !h) return null;
    var canvas = document.createElement("canvas");
    ((canvas.width = w), (canvas.height = h));
    var ctx = canvas.getContext("2d"),
      rgb = hexToRgb(colorHex);
    ctx.drawImage(img, 0, 0);
    for (
      var pixels = ctx.getImageData(0, 0, w, h), data = pixels.data, p = 0;
      p < data.length;
      p += 4
    )
      if (data[p + 3] !== 0) {
        var alpha = data[p + 3] / 255,
          light =
            (data[p] * 0.2126 + data[p + 1] * 0.7152 + data[p + 2] * 0.0722) /
            255,
          shade = 0.28 + Math.pow(light, 0.72) * 0.86,
          highlight = Math.max(0, (light - 0.86) / 0.14) * 18;
        ((data[p] = Math.min(255, rgb.r * shade + highlight)),
          (data[p + 1] = Math.min(255, rgb.g * shade + highlight)),
          (data[p + 2] = Math.min(255, rgb.b * shade + highlight)),
          (data[p + 3] = Math.round(Math.pow(alpha, 0.08) * 255)));
      }
    return (ctx.putImageData(pixels, 0, 0), canvas);
  }
  function flipCanvasH(src) {
    var c = document.createElement("canvas");
    ((c.width = src.width), (c.height = src.height));
    var ctx = c.getContext("2d");
    return (
      ctx.translate(src.width, 0),
      ctx.scale(-1, 1),
      ctx.drawImage(src, 0, 0),
      c
    );
  }
  function renderMockupMain(renderToken) {
    if (
      (typeof renderToken != "number" && (renderToken = ++S.renderToken),
      !!S.mockupType)
    ) {
      var urls = getMockupUrls(S.mockupType);
      if (urls) {
        var isFlipped = S.mockupView === "side_r",
          viewUrl = isFlipped ? urls.side : urls[S.mockupView] || urls.front;
        if (viewUrl) {
          var colorHex = colorFromName(S.selectedColor || ""),
            isLightColor = /^(white|weiss|weiß|off white|natural|natur)$/i.test(
              (S.selectedColor || "").trim(),
            );
          loadMaskImage(viewUrl, function (img) {
            if (renderToken === S.renderToken) {
              var imgEl = document.getElementById("des-product-img"),
                colorLayer = document.getElementById("des-product-color-layer");
              if (imgEl) {
                var coloredCanvas = colorizeImage(img, colorHex);
                (coloredCanvas &&
                  isFlipped &&
                  (coloredCanvas = flipCanvasH(coloredCanvas)),
                  (imgEl.src = coloredCanvas
                    ? coloredCanvas.toDataURL("image/png")
                    : viewUrl),
                  (imgEl.style.filter = "none"),
                  imgEl.classList.toggle(
                    "is-colorized",
                    !!coloredCanvas && !isLightColor,
                  ),
                  imgEl.classList.toggle("is-light-color", isLightColor),
                  (imgEl.style.transform = coloredCanvas
                    ? ""
                    : isFlipped
                      ? "scaleX(-1)"
                      : ""),
                  (imgEl.onload = function () {
                    ((S.renderCompletedToken = renderToken),
                      requestAnimationFrame(updateHandles));
                  }));
              }
              colorLayer &&
                ((colorLayer.style.backgroundColor = colorHex),
                (colorLayer.style.webkitMaskImage = 'url("' + viewUrl + '")'),
                (colorLayer.style.maskImage = 'url("' + viewUrl + '")'),
                (colorLayer.style.transform = isFlipped ? "scaleX(-1)" : ""),
                colorLayer.classList.remove("visible"));
            }
          });
        }
      }
    }
  }
  function renderMockupThumbs(renderToken) {
    if (S.mockupType) {
      var urls = getMockupUrls(S.mockupType);
      if (urls) {
        var colorHex = colorFromName(S.selectedColor || ""),
          views = ["front", "back", "side", "side_r"];
        views.forEach(function (view) {
          var isFlipped = view === "side_r",
            url = isFlipped ? urls.side : urls[view];
          if (url) {
            var thumbEl = document.getElementById("des-mt-" + view);
            thumbEl &&
              loadMaskImage(url, function (img) {
                if (renderToken === S.renderToken) {
                  var canvas = colorizeImage(img, colorHex);
                  if (canvas && renderToken === S.renderToken) {
                    isFlipped && (canvas = flipCanvasH(canvas));
                    var ctx = thumbEl.getContext("2d"),
                      tw = thumbEl.width,
                      th = thumbEl.height;
                    ctx.clearRect(0, 0, tw, th);
                    var scale = Math.min(tw / canvas.width, th / canvas.height),
                      dw = canvas.width * scale,
                      dh = canvas.height * scale;
                    ctx.drawImage(canvas, (tw - dw) / 2, (th - dh) / 2, dw, dh);
                  }
                }
              });
          }
        });
      }
    }
  }
  function renderMockup() {
    var renderToken = ++S.renderToken;
    (renderMockupMain(renderToken), renderMockupThumbs(renderToken));
  }
  function buildModal() {
    var colorOpt = getColorOption(),
      colorsHTML = "";
    colorOpt &&
      colorOpt.values &&
      colorOpt.values.forEach(function (v) {
        var vt = valTitle(v),
          visibleName = displayColorName(vt);
        colorsHTML +=
          '<button class="des-color" data-value="' +
          esc(vt) +
          '" title="' +
          esc(visibleName) +
          '" style="background:' +
          colorFromName(vt) +
          '" aria-label="' +
          esc(visibleName) +
          '"></button>';
      });
    var productSizes = getProductSizes(),
      sizesHTML = "";
    productSizes.forEach(function (v) {
      sizesHTML +=
        '<div class="des-size-row"><span class="des-size-label">' +
        esc(v) +
        '</span><input class="des-size-qty" type="number" min="0" value="0" data-size="' +
        esc(v) +
        '"></div>';
    });
    var thumbsHTML = "";
    if (S.mockupType) {
      var urls = getMockupUrls(S.mockupType) || {},
        VIEWS = [
          { key: "front", label: "Vorne" },
          { key: "back", label: "Hinten" },
          { key: "side", label: "\xC4rmel L" },
          { key: "side_r", label: "\xC4rmel R" },
        ];
      VIEWS.forEach(function (v) {
        (!urls[v.key] && !(v.key === "side_r" && urls.side)) ||
          (thumbsHTML +=
            '<div class="des-mt-wrap' +
            (v.key === "front" ? " active" : "") +
            '" data-view="' +
            v.key +
            '"><canvas class="des-mt-canvas" id="des-mt-' +
            v.key +
            '" width="52" height="52"></canvas><span class="des-mt-label">' +
            v.label +
            "</span></div>");
      });
    } else
      S.product &&
        S.product.images &&
        S.product.images.slice(0, 10).forEach(function (img, i) {
          var src = img.src || img,
            thumb = src.replace(/(\.[a-z]{2,4})(\?v=\d+)?$/i, "_100x$1$2"),
            full = src.replace(/(\.[a-z]{2,4})(\?v=\d+)?$/i, "_800x$1$2");
          thumbsHTML +=
            '<img class="des-thumb' +
            (i === 0 ? " active" : "") +
            '" src="' +
            thumb +
            '" data-full="' +
            full +
            '" alt="Ansicht ' +
            (i + 1) +
            '" draggable="false">';
        });
    var html =
        '<div id="aloe-designer-modal"><div class="des-header"><div class="des-header-brand"><img class="des-header-logo" src="' +
        (window.__aloeDesignerLogo || "") +
        '" alt="Aloe Textil"><span class="des-header-divider" aria-hidden="true"></span><div><div class="des-header-title">DESIGNER</div><div class="des-header-subtitle">Deine Idee direkt auf dem Textil</div></div></div><div class="des-progress" aria-label="Konfigurationsschritte"><span class="is-active"><b>1</b> Gestalten</span><i></i><span><b>2</b> Mengen &amp; Gr\xF6\xDFen ausw\xE4hlen</span><i></i><span><b>3</b> Anfrage abschicken</span></div><a href="#" class="des-close-btn" id="des-close-btn" aria-label="Schlie\xDFen"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></a></div><div class="des-main"><div class="des-left"><div class="des-panel-kicker">Dein Motiv</div><div class="des-panel-title">Logo hinzuf\xFCgen</div><details class="des-tools-details" open><summary>Entwurf &amp; Verlauf</summary><div class="des-session-actions"><button type="button" id="des-undo" disabled>\u21B6 Zur\xFCck</button><button type="button" id="des-redo" disabled>\u21B7 Wiederholen</button><button type="button" id="des-draft-save">Entwurf speichern</button><button type="button" id="des-draft-load">Entwurf laden</button><button type="button" id="des-reuse-logo">Gespeichertes Logo \xFCbernehmen</button><button type="button" id="des-sheet-download">Alle Ansichten herunterladen</button><small id="des-session-status" role="status">Entw\xFCrfe bleiben in diesem Browser gespeichert.</small></div></details><p class="des-panel-copy">PNG, JPG, WebP oder SVG hochladen und direkt auf dem Textil bearbeiten.</p><label class="des-left-btn" id="des-upload-btn" title="Logo hochladen"><input type="file" id="des-logo-input" accept="image/png,image/jpeg,image/svg+xml,image/webp"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg><span>Logo hochladen</span><small>Datei ausw\xE4hlen oder hier ablegen</small></label><div class="des-logo-thumb-wrap"><img class="des-logo-thumb" id="des-logo-thumb" alt="Logo-Vorschau"><button class="des-logo-add-hint" id="des-logo-add-hint" style="display:none" title="Logo auf diese Ansicht hinzuf\xFCgen">+ Hier</button></div><details class="des-edit-details" open><summary>Logo bearbeiten</summary><div class="des-logo-edit-actions" id="des-logo-edit-actions" aria-label="Logo bearbeiten"><button type="button" id="des-remove-bg" title="Einfarbigen Bildhintergrund transparent machen">Hintergrund entfernen</button><label for="des-bg-strength">Hintergrund-Toleranz</label><select id="des-bg-strength"><option value="36">Vorsichtig</option><option value="72" selected>Normal</option><option value="110">St\xE4rker</option></select><button type="button" id="des-crop-logo">Leere R\xE4nder abschneiden</button><div class="des-ink-actions"><button type="button" id="des-ink-black">Logo schwarz</button><button type="button" id="des-ink-white">Logo wei\xDF</button></div><button type="button" id="des-restore-logo" title="Unbearbeitetes Logo wiederherstellen" disabled>Original</button><small id="des-logo-edit-status" aria-live="polite">Am besten f\xFCr wei\xDFe oder einfarbige Hintergr\xFCnde.</small><small id="des-quality-status" role="status"></small><label for="des-placement">Startposition</label><select id="des-placement"><option value="">Position w\xE4hlen \u2026</option><option value="middle">Mittig</option><option value="left">Brust links (Tr\xE4gersicht)</option><option value="right">Brust rechts (Tr\xE4gersicht)</option></select><small>Vorschlag zur Orientierung \u2013 anschlie\xDFend frei verschieben.</small></div></details><button class="des-left-btn" id="des-help-btn" title="Hilfe"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>Hilfe</button></div><div class="des-center"><div class="des-logo-toolbar" id="des-logo-toolbar"><div class="des-dpi-badge" id="des-dpi-badge"><span class="des-dpi-dot" id="des-dpi-dot"></span><span id="des-dpi-text">DPI</span></div><div class="des-toolbar-group"><label class="des-toolbar-label">Gr\xF6\xDFe</label><input type="range" id="des-scale-slider" min="6" max="150" value="18" step="1"><span id="des-scale-val">18%</span></div><div class="des-toolbar-group"><label class="des-toolbar-label">Drehen</label><button class="des-rot-btn" id="des-rot-left" title="Links drehen">\u21BA</button><span id="des-rot-val">0\xB0</span><button class="des-rot-btn" id="des-rot-right" title="Rechts drehen">\u21BB</button></div><div class="des-toolbar-sep"></div><div class="des-toolbar-group"><button class="des-rot-btn" id="des-flip-h" title="Spiegeln (F)" style="width:auto;padding:0 8px;font-size:11px;">\u21D4 Flip</button></div><div class="des-toolbar-sep"></div><button class="des-rot-btn des-center-btn" id="des-center-btn" title="Zentrieren (C)">\u2295 Mitte</button><button class="des-rot-btn des-dl-btn" id="des-dl-btn" title="Aktuelle Ansicht als PNG herunterladen">\u2193 Ansicht downloaden</button><button class="des-toolbar-reset" id="des-logo-reset" title="Logo entfernen">\u2715 Reset</button></div><div class="des-product-wrap" id="des-product-wrap"><div class="des-product-color-layer" id="des-product-color-layer" aria-hidden="true"></div><img id="des-product-img" alt="Produktvorschau" draggable="false"><div class="des-zip-guide" id="des-zip-guide" aria-hidden="true"><span>Rei\xDFverschluss<br>nicht bedruckbar</span></div><img id="des-logo-overlay" alt="Hochgeladenes Logo" draggable="false"><div id="des-logo-handles" aria-label="Logo direkt bearbeiten"><button type="button" class="des-lh des-lh-tl" data-action="resize" aria-label="Logo von links oben skalieren" title="Ziehen zum Vergr\xF6\xDFern oder Verkleinern"></button><button type="button" class="des-lh des-lh-tr" data-action="resize" aria-label="Logo von rechts oben skalieren" title="Ziehen zum Vergr\xF6\xDFern oder Verkleinern"></button><button type="button" class="des-lh des-lh-bl" data-action="resize" aria-label="Logo von links unten skalieren" title="Ziehen zum Vergr\xF6\xDFern oder Verkleinern"></button><button type="button" class="des-lh des-lh-br" data-action="resize" aria-label="Logo von rechts unten skalieren" title="Ziehen zum Vergr\xF6\xDFern oder Verkleinern"></button><button type="button" class="des-lh des-lh-rot" data-action="rotate" aria-label="Logo frei drehen" title="Ziehen zum freien Drehen"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round"><path d="M21 12a9 9 0 1 1-9-9"/><polyline points="16 3 21 3 21 8"/></svg></button></div><div class="des-drop-hint" id="des-drop-hint">Logo hochladen &amp; auf das Produkt klicken zum Positionieren</div></div><div class="des-thumbs" id="des-thumbs">' +
        thumbsHTML +
        '</div></div><div class="des-right"><div class="des-section"><div class="des-section-title">Veredelungsart</div><select class="des-select" id="des-method-select"><option value="druck">Druck</option><option value="stick">Stickerei</option><option value="druck-stick">Druck &amp; Stickerei</option></select></div>' +
        (colorsHTML
          ? '<div class="des-section"><div class="des-section-title">Farben</div><div class="des-colors" id="des-colors">' +
            colorsHTML +
            '</div><div class="des-color-label" id="des-color-label"></div></div>'
          : "") +
        (productSizes.length
          ? '<div class="des-section"><div class="des-section-title">Mengen &amp; Gr\xF6\xDFen w\xE4hlen</div><div class="des-sizes-grid" id="des-sizes-grid">' +
            sizesHTML +
            '</div><div class="des-nosize-note">Gr\xF6\xDFen k\xF6nnen frei kombiniert werden. Bitte f\xFCr jede ben\xF6tigte Gr\xF6\xDFe die St\xFCckzahl eintragen.</div></div>'
          : '<div class="des-section"><div class="des-section-title">St\xFCckzahl w\xE4hlen</div><div class="des-nosize-row"><span class="des-nosize-label">Artikel ohne Gr\xF6\xDFenwahl</span><input class="des-nosize-qty" type="number" id="des-nosize-qty" min="0" value="0" aria-label="St\xFCckzahl"></div><div class="des-nosize-note">F\xFCr diesen Artikel ist keine Gr\xF6\xDFe erforderlich.</div></div>') +
        '<div class="des-section" id="des-summary-section" style="display:none;"><div class="des-section-title">Zusammenfassung</div><div class="des-summary-box" id="des-summary-box"></div></div><div class="des-section" style="margin-top:auto;"><button class="des-save-btn" id="des-save-btn" disabled style="opacity:0.45;cursor:not-allowed;" title="Mindestbestellmenge: 5 St\xFCck pro Produkt (Gr\xF6\xDFen k\xF6nnen gemischt werden)"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>Konfiguration<br>speichern</button></div></div></div></div>',
      overlay = document.createElement("div");
    ((overlay.id = "aloe-designer-overlay"),
      (overlay.dataset.mockupType = S.mockupType || "product-image"),
      (overlay.dataset.frontZipper = S.hasFrontZipper ? "true" : "false"),
      (overlay.innerHTML = html),
      document.body.appendChild(overlay));
  }
  function updateZipperGuide() {
    var guide = document.getElementById("des-zip-guide");
    guide &&
      guide.classList.toggle(
        "visible",
        !!(S.hasFrontZipper && S.mockupView === "front"),
      );
  }
  function constrainLogoToPrintableArea() {
    if (!(!S.hasFrontZipper || S.mockupView !== "front" || !S.logoSrc)) {
      var side = S.logoPosX < 50 ? -1 : 1,
        edgeGap = 3,
        halfWidth = Math.max(2, S.logoScale / 2),
        maxScaleForSide = Math.max(
          6,
          2 * (Math.abs(S.logoPosX - 50) - edgeGap),
        );
      ((S.logoScale = Math.min(S.logoScale, maxScaleForSide)),
        (halfWidth = S.logoScale / 2),
        side < 0
          ? (S.logoPosX = Math.min(
              50 - edgeGap - halfWidth,
              Math.max(3 + halfWidth, S.logoPosX),
            ))
          : (S.logoPosX = Math.max(
              50 + edgeGap + halfWidth,
              Math.min(97 - halfWidth, S.logoPosX),
            )));
      var slider = document.getElementById("des-scale-slider"),
        value = document.getElementById("des-scale-val");
      (slider && (slider.value = Math.round(S.logoScale)),
        value && (value.textContent = Math.round(S.logoScale) + "%"));
    }
  }
  function applyLogoTransform() {
    var el = document.getElementById("des-logo-overlay");
    el &&
      (constrainLogoToPrintableArea(),
      updateZipperGuide(),
      (el.style.left = S.logoPosX + "%"),
      (el.style.top = S.logoPosY + "%"),
      (el.style.width = S.logoScale + "%"),
      (el.style.transform =
        "translate(-50%, -50%) rotate(" +
        S.logoRotation +
        "deg)" +
        (S.logoFlipH ? " scaleX(-1)" : "")),
      requestAnimationFrame(updateHandles),
      updateDPI(),
      scheduleEdit());
  }
  function updateHandles() {
    var logoEl = document.getElementById("des-logo-overlay"),
      handlesEl = document.getElementById("des-logo-handles");
    if (!(!logoEl || !handlesEl)) {
      if (!logoEl.classList.contains("visible")) {
        handlesEl.classList.remove("visible");
        return;
      }
      var wrap = document.getElementById("des-product-wrap");
      if (wrap) {
        var wr = wrap.getBoundingClientRect(),
          lr = logoEl.getBoundingClientRect(),
          cx = lr.left + lr.width / 2 - wr.left,
          cy = lr.top + lr.height / 2 - wr.top;
        ((handlesEl.style.left = cx + "px"),
          (handlesEl.style.top = cy + "px"),
          (handlesEl.style.width = logoEl.offsetWidth + "px"),
          (handlesEl.style.height = logoEl.offsetHeight + "px"),
          (handlesEl.style.transform =
            "translate(-50%,-50%) rotate(" + S.logoRotation + "deg)"),
          handlesEl.classList.add("visible"));
      }
    }
  }
  function updateDPI() {
    var badge = document.getElementById("des-dpi-badge");
    badge && (badge.style.display = "none");
    var status = document.getElementById("des-quality-status");
    if (!(!status || !S.logoSrc)) {
      var vector =
        S.logoFile &&
        S.logoFile.type === "image/svg+xml" &&
        S.logoSrc === S.logoOriginalSrc;
      status.textContent = vector
        ? "SVG-Datei: Wir pr\xFCfen die Druckdaten vor der Produktion."
        : S.logoNatW < 600 || S.logoNatH < 200
          ? "Kleine Bilddatei (" +
            S.logoNatW +
            " \xD7 " +
            S.logoNatH +
            " px). Bitte m\xF6glichst das hochaufl\xF6sende Original verwenden. Die Eignung h\xE4ngt von der gew\xFCnschten Druckgr\xF6\xDFe ab."
          : "Bilddatei: " +
            S.logoNatW +
            " \xD7 " +
            S.logoNatH +
            " px. Die endg\xFCltige Druckgr\xF6\xDFe und Umsetzbarkeit pr\xFCfen wir pers\xF6nlich.";
    }
  }
  function onLogoUpload(e) {
    var file = e.target.files[0];
    if (file) {
      if (
        !/^image\/(png|jpeg|webp|svg\+xml)$/.test(file.type) ||
        file.size > 20 * 1024 * 1024
      ) {
        sessionStatus(
          "Bitte PNG, JPG, WebP oder SVG mit h\xF6chstens 20 MB w\xE4hlen.",
        );
        return;
      }
      var reader = new FileReader();
      ((reader.onload = function (ev) {
        var img = new Image();
        ((img.onload = function () {
          ((S.logoFile = file),
            (S.logoSrc = ev.target.result),
            (S.logoOriginalSrc = ev.target.result),
            (S.logoNatW = img.naturalWidth),
            (S.logoNatH = img.naturalHeight));
          var logoEl = document.getElementById("des-logo-overlay");
          ((logoEl.onload = function () {
            (applyLogoTransform(), requestAnimationFrame(updateHandles));
          }),
            (logoEl.src = S.logoSrc),
            logoEl.classList.add("visible"));
          var thumb = document.getElementById("des-logo-thumb");
          ((thumb.src = S.logoSrc),
            thumb.classList.add("visible"),
            document.getElementById("des-upload-btn").classList.add("has-logo"),
            document
              .getElementById("des-logo-edit-actions")
              .classList.add("visible"),
            (document.getElementById("des-restore-logo").disabled = !0),
            setLogoEditStatus(
              "Am besten f\xFCr wei\xDFe oder einfarbige Hintergr\xFCnde.",
            ));
          var hint = document.getElementById("des-drop-hint");
          hint && (hint.style.display = "none");
          var toolbar = document.getElementById("des-logo-toolbar");
          (toolbar && toolbar.classList.add("visible"),
            S.viewLogos[S.mockupView] &&
              (S.viewLogos[S.mockupView].active = !0),
            applyLogoTransform(),
            setTimeout(updateHandles, 80),
            saveViewLogo(),
            updateThumbBadges(),
            updateLogoThumbHint());
        }),
          (img.onerror = function () {
            sessionStatus(
              "Diese Bilddatei konnte nicht ge\xF6ffnet werden. Bitte eine andere Datei w\xE4hlen.",
            );
          }),
          (img.src = ev.target.result));
      }),
        (reader.onerror = function () {
          sessionStatus(
            "Die Datei konnte nicht gelesen werden. Bitte erneut ausw\xE4hlen.",
          );
        }),
        reader.readAsDataURL(file));
    }
  }
  function setLogoEditStatus(message, isError) {
    var status = document.getElementById("des-logo-edit-status");
    status &&
      ((status.textContent = message),
      status.classList.toggle("is-error", !!isError));
  }
  function setLogoImageSource(src) {
    S.logoSrc = src;
    var logoEl = document.getElementById("des-logo-overlay"),
      thumb = document.getElementById("des-logo-thumb");
    ((logoEl.onload = function () {
      ((S.logoNatW = logoEl.naturalWidth),
        (S.logoNatH = logoEl.naturalHeight),
        applyLogoTransform(),
        requestAnimationFrame(updateHandles));
    }),
      (logoEl.src = src),
      (thumb.src = src),
      (document.getElementById("des-restore-logo").disabled =
        src === S.logoOriginalSrc));
  }
  function removeLogoBackground() {
    if (S.logoOriginalSrc) {
      var source = S.logoSrc,
        tolerance =
          Number(document.getElementById("des-bg-strength").value) || 72,
        btn = document.getElementById("des-remove-bg");
      ((btn.disabled = !0),
        setLogoEditStatus("Hintergrund wird gepr\xFCft \u2026"));
      var img = new Image();
      ((img.onload = function () {
        try {
          var similar = function (index2) {
              var p = index2 * 4,
                dr = data[p] - bg[0],
                dg = data[p + 1] - bg[1],
                db = data[p + 2] - bg[2];
              return (
                data[p + 3] < 20 ||
                Math.sqrt(dr * dr + dg * dg + db * db) < tolerance
              );
            },
            add = function (index2) {
              index2 < 0 ||
                index2 >= seen.length ||
                seen[index2] ||
                !similar(index2) ||
                ((seen[index2] = 1), (queue[tail++] = index2));
            },
            maxSide = 1800,
            ratio = Math.min(
              1,
              maxSide / Math.max(img.naturalWidth, img.naturalHeight),
            ),
            w = Math.max(1, Math.round(img.naturalWidth * ratio)),
            h = Math.max(1, Math.round(img.naturalHeight * ratio)),
            canvas = document.createElement("canvas");
          ((canvas.width = w), (canvas.height = h));
          var ctx = canvas.getContext("2d", { willReadFrequently: !0 });
          ctx.drawImage(img, 0, 0, w, h);
          var imageData = ctx.getImageData(0, 0, w, h),
            data = imageData.data,
            patch = Math.max(
              1,
              Math.min(w, h, 12, Math.round(Math.min(w, h) * 0.025)),
            ),
            sum = [0, 0, 0],
            count = 0;
          if (
            ([
              [0, 0],
              [w - patch, 0],
              [0, h - patch],
              [w - patch, h - patch],
            ].forEach(function (corner) {
              for (var y2 = corner[1]; y2 < corner[1] + patch; y2++)
                for (var x2 = corner[0]; x2 < corner[0] + patch; x2++) {
                  var p = (y2 * w + x2) * 4;
                  data[p + 3] > 20 &&
                    ((sum[0] += data[p]),
                    (sum[1] += data[p + 1]),
                    (sum[2] += data[p + 2]),
                    count++);
                }
            }),
            !count)
          ) {
            (setLogoEditStatus(
              "Das Logo hat bereits einen transparenten Hintergrund.",
            ),
              (btn.disabled = !1));
            return;
          }
          for (
            var bg = [sum[0] / count, sum[1] / count, sum[2] / count],
              seen = new Uint8Array(w * h),
              queue = new Int32Array(w * h),
              head = 0,
              tail = 0,
              removed = 0,
              x = 0;
            x < w;
            x++
          )
            (add(x), add((h - 1) * w + x));
          for (var y = 0; y < h; y++) (add(y * w), add(y * w + w - 1));
          for (; head < tail; ) {
            var index = queue[head++],
              px = index % w;
            ((data[index * 4 + 3] = 0),
              removed++,
              px > 0 && add(index - 1),
              px < w - 1 && add(index + 1),
              add(index - w),
              add(index + w));
          }
          if (source !== S.logoSrc) {
            btn.disabled = !1;
            return;
          }
          (removed > w * h * 0.97
            ? setLogoEditStatus(
                "Dabei w\xFCrde fast das ganze Motiv verschwinden. Bitte \u201EVorsichtig\u201C w\xE4hlen oder uns die Datei zur Pr\xFCfung senden.",
                !0,
              )
            : removed < w * h * 0.005
              ? setLogoEditStatus(
                  "Kein zusammenh\xE4ngender, einfarbiger Hintergrund erkannt.",
                  !0,
                )
              : (ctx.putImageData(imageData, 0, 0),
                setLogoImageSource(canvas.toDataURL("image/png")),
                setLogoEditStatus(
                  "Hintergrund entfernt. Bitte feine Konturen pr\xFCfen. Mit \u201EOriginal\u201C kannst du zur\xFCckwechseln.",
                )),
            (btn.disabled = !1));
        } catch (error) {
          setLogoEditStatus(
            "Der Hintergrund konnte nicht sicher entfernt werden. Bitte das Original verwenden.",
            !0,
          );
        } finally {
          btn.disabled = !1;
        }
      }),
        (img.onerror = function () {
          ((btn.disabled = !1),
            setLogoEditStatus("Das Bild konnte nicht bearbeitet werden.", !0));
        }),
        (img.src = source));
    }
  }
  function editLogoPixels(action) {
    if (S.logoSrc) {
      var source = S.logoSrc,
        image = new Image();
      ((image.onload = function () {
        if (source === S.logoSrc)
          try {
            var width = image.naturalWidth,
              height = image.naturalHeight;
            if (width * height > 12e6)
              throw new Error(
                "Diese Datei ist f\xFCr die Browserbearbeitung sehr gro\xDF. Bitte sende uns das Original zur Aufbereitung.",
              );
            var canvas = document.createElement("canvas");
            ((canvas.width = width), (canvas.height = height));
            var ctx = canvas.getContext("2d", { willReadFrequently: !0 });
            ctx.drawImage(image, 0, 0);
            for (
              var pixels = ctx.getImageData(0, 0, width, height),
                data = pixels.data,
                left = width,
                right = -1,
                top = height,
                bottom = -1,
                transparent = 0,
                y = 0;
              y < height;
              y++
            )
              for (var x = 0; x < width; x++) {
                var index = (y * width + x) * 4;
                if (data[index + 3] < 10) {
                  transparent++;
                  continue;
                }
                ((left = Math.min(left, x)),
                  (right = Math.max(right, x)),
                  (top = Math.min(top, y)),
                  (bottom = Math.max(bottom, y)),
                  action !== "crop" &&
                    (data[index] =
                      data[index + 1] =
                      data[index + 2] =
                        action === "white" ? 255 : 0));
              }
            if (right < left)
              throw new Error(
                "In der Datei ist kein sichtbares Motiv vorhanden. Bitte das Original wiederherstellen.",
              );
            if (action === "crop") {
              if (!left && !top && right === width - 1 && bottom === height - 1)
                throw new Error(
                  "Keine transparenten Au\xDFenr\xE4nder erkannt. Entferne gegebenenfalls zuerst den Hintergrund.",
                );
              var cropped = document.createElement("canvas");
              ((cropped.width = right - left + 1),
                (cropped.height = bottom - top + 1),
                cropped
                  .getContext("2d")
                  .drawImage(
                    canvas,
                    left,
                    top,
                    cropped.width,
                    cropped.height,
                    0,
                    0,
                    cropped.width,
                    cropped.height,
                  ),
                saveViewLogo());
              var frame = document
                .getElementById("des-product-wrap")
                .getBoundingClientRect();
              Object.keys(S.viewLogos).forEach(function (key) {
                var view = S.viewLogos[key];
                if (view.active) {
                  var dx =
                      ((left + cropped.width / 2 - width / 2) / width) *
                      view.scale,
                    dy =
                      ((top + cropped.height / 2 - height / 2) / width) *
                      view.scale;
                  view.flipH && (dx = -dx);
                  var angle = (view.rotation * Math.PI) / 180;
                  ((view.posX += dx * Math.cos(angle) - dy * Math.sin(angle)),
                    (view.posY +=
                      ((dx * Math.sin(angle) + dy * Math.cos(angle)) *
                        frame.width) /
                      Math.max(1, frame.height)),
                    (view.scale *= cropped.width / width));
                }
              });
              var current = S.viewLogos[S.mockupView];
              ((S.logoPosX = current.posX),
                (S.logoPosY = current.posY),
                (S.logoScale = current.scale),
                setLogoImageSource(cropped.toDataURL("image/png")),
                setLogoEditStatus(
                  "Transparente R\xE4nder entfernt. Bitte Gr\xF6\xDFe und Position auf allen gestalteten Seiten pr\xFCfen.",
                ));
            } else {
              if (transparent < width * height * 0.005)
                throw new Error(
                  "Bitte zuerst den Hintergrund entfernen. Sonst w\xFCrde auch der Hintergrund eingef\xE4rbt.",
                );
              (ctx.putImageData(pixels, 0, 0),
                setLogoImageSource(canvas.toDataURL("image/png")),
                setLogoEditStatus(
                  "Motiv einfarbig " +
                    (action === "white" ? "wei\xDF" : "schwarz") +
                    ". Transparenz bleibt erhalten. \u201EOriginal\u201C stellt alle Farben wieder her.",
                ));
            }
          } catch (error) {
            setLogoEditStatus(
              error.message || "Die Datei konnte nicht bearbeitet werden.",
              !0,
            );
          }
      }),
        (image.onerror = function () {
          setLogoEditStatus("Die Datei konnte nicht ge\xF6ffnet werden.", !0);
        }),
        (image.src = source));
    }
  }
  function startDrag(e) {
    S.logoSrc &&
      ((typeof e.button == "number" && e.button !== 0) ||
        ((S.dragging = !0),
        (S.dragStartX = e.clientX),
        (S.dragStartY = e.clientY),
        (S.dragStartPosX = S.logoPosX),
        (S.dragStartPosY = S.logoPosY),
        e.currentTarget &&
          e.currentTarget.setPointerCapture &&
          e.pointerId !== void 0 &&
          e.currentTarget.setPointerCapture(e.pointerId),
        e.preventDefault()));
  }
  function moveDrag(e) {
    if (S.dragging) {
      var wrap = document.getElementById("des-product-wrap");
      if (wrap) {
        var r = wrap.getBoundingClientRect(),
          dx = ((e.clientX - S.dragStartX) / r.width) * 100,
          dy = ((e.clientY - S.dragStartY) / r.height) * 100;
        ((S.logoPosX = Math.max(2, Math.min(98, S.dragStartPosX + dx))),
          (S.logoPosY = Math.max(2, Math.min(98, S.dragStartPosY + dy))),
          applyLogoTransform());
      }
    }
  }
  function stopDrag() {
    S.dragging = !1;
  }
  var TX = {
    mode: null,
    startDist: 0,
    startScale: 0,
    startAngle: 0,
    startRot: 0,
    cx: 0,
    cy: 0,
  };
  function getClientXY(e) {
    return e.touches && e.touches.length
      ? { x: e.touches[0].clientX, y: e.touches[0].clientY }
      : { x: e.clientX, y: e.clientY };
  }
  function startHandleAction(e) {
    var action = e.currentTarget.dataset.action;
    if (
      !(!action || !S.logoSrc) &&
      !(typeof e.button == "number" && e.button !== 0)
    ) {
      e.currentTarget &&
        e.currentTarget.setPointerCapture &&
        e.pointerId !== void 0 &&
        e.currentTarget.setPointerCapture(e.pointerId);
      var logoEl = document.getElementById("des-logo-overlay");
      if (logoEl) {
        var r = logoEl.getBoundingClientRect();
        ((TX.cx = r.left + r.width / 2), (TX.cy = r.top + r.height / 2));
        var pt = getClientXY(e);
        (action === "resize"
          ? ((TX.mode = "resize"),
            (TX.startDist =
              Math.sqrt(
                Math.pow(pt.x - TX.cx, 2) + Math.pow(pt.y - TX.cy, 2),
              ) || 1),
            (TX.startScale = S.logoScale))
          : ((TX.mode = "rotate"),
            (TX.startAngle =
              (Math.atan2(pt.y - TX.cy, pt.x - TX.cx) * 180) / Math.PI),
            (TX.startRot = S.logoRotation)),
          e.preventDefault(),
          e.stopPropagation());
      }
    }
  }
  function onHandleMove(e) {
    if (TX.mode) {
      var pt = getClientXY(e);
      if (TX.mode === "resize") {
        var dist =
          Math.sqrt(Math.pow(pt.x - TX.cx, 2) + Math.pow(pt.y - TX.cy, 2)) || 1;
        S.logoScale = Math.max(
          4,
          Math.min(150, (TX.startScale * dist) / TX.startDist),
        );
        var sl = document.getElementById("des-scale-slider");
        sl &&
          ((sl.value = Math.round(S.logoScale)),
          (document.getElementById("des-scale-val").textContent =
            Math.round(S.logoScale) + "%"));
      } else {
        var angle = (Math.atan2(pt.y - TX.cy, pt.x - TX.cx) * 180) / Math.PI;
        S.logoRotation =
          (((TX.startRot + angle - TX.startAngle) % 360) + 360) % 360;
        var rv = document.getElementById("des-rot-val");
        rv && (rv.textContent = Math.round(S.logoRotation) + "\xB0");
      }
      (applyLogoTransform(), e.preventDefault());
    }
  }
  function stopHandleAction(e) {
    (e &&
      e.target &&
      e.target.releasePointerCapture &&
      e.pointerId !== void 0 &&
      e.target.hasPointerCapture &&
      e.target.hasPointerCapture(e.pointerId) &&
      e.target.releasePointerCapture(e.pointerId),
      (TX.mode = null),
      saveViewLogo());
  }
  function startTouch(e) {
    e.touches.length !== 1 ||
      !S.logoSrc ||
      (startDrag({
        clientX: e.touches[0].clientX,
        clientY: e.touches[0].clientY,
        preventDefault: function () {},
      }),
      e.preventDefault());
  }
  function moveTouch(e) {
    !S.dragging ||
      e.touches.length !== 1 ||
      (moveDrag({
        clientX: e.touches[0].clientX,
        clientY: e.touches[0].clientY,
      }),
      e.preventDefault());
  }
  function onWrapClick(e) {
    if (
      S.logoSrc &&
      !(
        e.target.id === "des-logo-overlay" ||
        (e.target.closest && e.target.closest("#des-logo-handles"))
      )
    ) {
      var wrap = document.getElementById("des-product-wrap"),
        r = wrap.getBoundingClientRect();
      ((S.logoPosX = ((e.clientX - r.left) / r.width) * 100),
        (S.logoPosY = ((e.clientY - r.top) / r.height) * 100),
        applyLogoTransform());
    }
  }
  function setProductImage(url) {
    var img = document.getElementById("des-product-img");
    if (!(!img || !url)) {
      (img.classList.remove("is-colorized"), (img.style.transform = ""));
      var colorLayer = document.getElementById("des-product-color-layer");
      (colorLayer && colorLayer.classList.remove("visible"),
        (img.src = url),
        (img.onload = function () {
          requestAnimationFrame(updateHandles);
        }));
    }
  }
  function updateVariantImage() {
    if (S.selectedColor) {
      var v = findVariant(S.selectedColor);
      if (v && v.featured_image && v.featured_image.src) {
        var src = v.featured_image.src.replace(
          /(\.[a-z]{2,4})(\?v=\d+)?$/i,
          "_800x$1$2",
        );
        setProductImage(src);
      }
    }
  }
  var DES_MIN_QTY = 5;
  function invalidDesignerQuantity() {
    return Array.from(document.querySelectorAll(".des-size-qty,#des-nosize-qty")).find(function (input) {
      var value = Number(input.value || 0);
      var invalid = input.validity.badInput || !Number.isSafeInteger(value) || value < 0;
      input.setAttribute("aria-invalid", String(invalid));
      return invalid;
    });
  }
  function updateSummary() {
    var lines = [],
      total = 0;
    document.querySelectorAll(".des-size-qty").forEach(function (inp) {
      var qty = parseInt(inp.value) || 0;
      qty > 0 &&
        (lines.push(inp.dataset.size + ": <strong>" + qty + "</strong>"),
        (total += qty));
    });
    var ns =
      parseInt((document.getElementById("des-nosize-qty") || {}).value) || 0;
    ns > 0 &&
      (lines.push("Ohne Gr\xF6\xDFe: <strong>" + ns + "</strong>"),
      (total += ns));
    var section = document.getElementById("des-summary-section"),
      box = document.getElementById("des-summary-box"),
      saveBtn = document.getElementById("des-save-btn");
    if (
      !(!section || !box) &&
      (lines.length
        ? (S.selectedColor &&
            lines.unshift(
              "Farbe: <strong>" +
                esc(displayColorName(S.selectedColor)) +
                "</strong>",
            ),
          lines.push(
            '<hr style="border:none;border-top:1px solid #ddd;margin:4px 0;">',
          ),
          total < DES_MIN_QTY
            ? lines.push(
                "Gesamt: <strong>" +
                  total +
                  ' Stk.</strong> &nbsp;<span style="color:#e05a5a;font-size:11px;font-weight:600;">\u26A0 Noch ' +
                  (DES_MIN_QTY - total) +
                  " Stk. bis zur Mindestmenge</span>",
              )
            : lines.push(
                "Gesamt: <strong>" +
                  total +
                  ' Stk.</strong> &nbsp;<span style="color:#4caf50;font-size:11px;font-weight:600;">\u2713 Mindestmenge erreicht</span>',
              ),
          (box.innerHTML = lines.join("<br>")),
          (section.style.display = ""))
        : (section.style.display = "none"),
      saveBtn)
    ) {
      var invalid = invalidDesignerQuantity();
      var ok = total >= DES_MIN_QTY && !invalid;
      if (invalid) {
        box.textContent = invalid.validationMessage;
        section.style.display = "";
      }
      ((saveBtn.disabled = !ok),
        (saveBtn.style.opacity = ok ? "" : "0.45"),
        (saveBtn.style.cursor = ok ? "" : "not-allowed"),
        (saveBtn.title = ok
          ? ""
          : "Mindestbestellmenge: " +
            DES_MIN_QTY +
            " St\xFCck pro Produkt (Gr\xF6\xDFen k\xF6nnen gemischt werden)"));
    }
  }
  function applyUpsellQuantity() {
    if (UPSELL_FLOW.active) {
      var sizeInputs = Array.prototype.slice.call(
          document.querySelectorAll(".des-size-qty"),
        ),
        target =
          sizeInputs.find(function (input) {
            return /^(one size|onesize|einheitsgröße|einheitsgroesse)$/i.test(
              (input.dataset.size || "").trim(),
            );
          }) || sizeInputs[0],
        noSizeInput = document.getElementById("des-nosize-qty");
      (target
        ? (target.value = UPSELL_FLOW.quantity)
        : noSizeInput && (noSizeInput.value = UPSELL_FLOW.quantity),
        updateSummary());
    }
  }
  function createDesignerViewFile(configurationId) {
    return new Promise(function (resolve, reject) {
      var productImg = document.getElementById("des-product-img"),
        logoEl = document.getElementById("des-logo-overlay");
      if (!productImg || !productImg.src || !logoEl || !S.logoSrc) {
        resolve(null);
        return;
      }
      var productRect = productImg.getBoundingClientRect(),
        frameRect = document
          .getElementById("des-product-wrap")
          .getBoundingClientRect(),
        logoRect = logoEl.getBoundingClientRect();
      if (!productRect.width || !productRect.height) {
        resolve(null);
        return;
      }
      var outputScale = Math.min(2, 1200 / frameRect.width),
        canvas = document.createElement("canvas");
      ((canvas.width = Math.max(1, Math.round(frameRect.width * outputScale))),
        (canvas.height = Math.max(
          1,
          Math.round(frameRect.height * outputScale),
        )));
      var ctx = canvas.getContext("2d"),
        product = new Image();
      ((product.crossOrigin = "anonymous"),
        (product.onload = function () {
          ((ctx.fillStyle = "#ffffff"),
            ctx.fillRect(0, 0, canvas.width, canvas.height),
            ctx.drawImage(
              product,
              (productRect.left - frameRect.left) * outputScale,
              (productRect.top - frameRect.top) * outputScale,
              productRect.width * outputScale,
              productRect.height * outputScale,
            ));
          var logo = new Image();
          ((logo.onload = function () {
            try {
              var centerX =
                  (logoRect.left - frameRect.left + logoRect.width / 2) *
                  outputScale,
                centerY =
                  (logoRect.top - frameRect.top + logoRect.height / 2) *
                  outputScale;
              (ctx.save(),
                ctx.translate(centerX, centerY),
                ctx.rotate((S.logoRotation * Math.PI) / 180),
                S.logoFlipH && ctx.scale(-1, 1),
                ctx.drawImage(
                  logo,
                  (-logoEl.offsetWidth * outputScale) / 2,
                  (-logoEl.offsetHeight * outputScale) / 2,
                  logoEl.offsetWidth * outputScale,
                  logoEl.offsetHeight * outputScale,
                ),
                ctx.restore(),
                canvas.toBlob(
                  function (blob) {
                    if (!blob) {
                      resolve(null);
                      return;
                    }
                    var viewName =
                        {
                          front: "vorne",
                          back: "hinten",
                          side: "links",
                          side_r: "rechts",
                        }[S.mockupView] || S.mockupView,
                      safeConfigurationId = String(configurationId || "aloe")
                        .replace(/[^a-z0-9-]/gi, "-")
                        .toLowerCase();
                    resolve(
                      new File(
                        [blob],
                        safeConfigurationId +
                          "-gestaltungsansicht-" +
                          viewName +
                          ".png",
                        { type: "image/png" },
                      ),
                    );
                  },
                  "image/png",
                  0.94,
                ));
            } catch (error) {
              reject(
                new Error(
                  "Die Vorschau konnte nicht exportiert werden. Bitte die Bilddatei pr\xFCfen.",
                ),
              );
            }
          }),
            (logo.onerror = function () {
              resolve(null);
            }),
            (logo.src = S.logoSrc));
        }),
        (product.onerror = function () {
          resolve(null);
        }),
        (product.src = productImg.src));
    });
  }
  function waitForDesignerImage() {
    var token = S.renderToken,
      started = Date.now();
    return new Promise(function (resolve, reject) {
      function check() {
        var image = document.getElementById("des-product-img");
        image &&
        image.complete &&
        image.naturalWidth &&
        (!S.mockupType || S.renderCompletedToken === token)
          ? requestAnimationFrame(function () {
              requestAnimationFrame(resolve);
            })
          : Date.now() - started > 15e3
            ? reject(
                new Error(
                  "Eine Produktansicht konnte nicht geladen werden. Bitte erneut versuchen.",
                ),
              )
            : setTimeout(check, 60);
      }
      check();
    });
  }
  function previewImage(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file),
        image = new Image();
      ((image.onload = function () {
        (URL.revokeObjectURL(url), resolve(image));
      }),
        (image.onerror = function () {
          (URL.revokeObjectURL(url),
            reject(new Error("Vorschau konnte nicht erstellt werden.")));
        }),
        (image.src = url));
    });
  }
  function createDesignerPreviewFile(configurationId) {
    saveViewLogo();
    var originalView = S.mockupView,
      views = Object.keys(S.viewLogos).filter(function (view) {
        return S.viewLogos[view].active;
      });
    if (!views.length)
      return Promise.reject(
        new Error("Bitte das Logo auf mindestens einer Ansicht platzieren."),
      );
    S.mockupType || (views = [originalView]);
    var main = document.querySelector("#aloe-designer-modal .des-main");
    ((main.inert = !0), (S.exporting = !0));
    var captures = [];
    return views
      .reduce(function (chain, view) {
        return chain
          .then(function () {
            return (
              (S.mockupView = view),
              S.mockupType && renderMockupMain(),
              loadViewLogo(view),
              waitForDesignerImage()
            );
          })
          .then(function () {
            return createDesignerViewFile(configurationId);
          })
          .then(function (file) {
            if (!file)
              throw new Error(
                "Die Gestaltung konnte nicht vollst\xE4ndig exportiert werden.",
              );
            return previewImage(file);
          })
          .then(function (image) {
            captures.push({ view: view, image: image });
          });
      }, Promise.resolve())
      .then(function () {
        var canvas = document.createElement("canvas"),
          columns = Math.min(2, captures.length),
          quantities = Array.from(document.querySelectorAll(".des-size-qty"))
            .filter(function (el) {
              return Number(el.value) > 0;
            })
            .map(function (el) {
              return el.dataset.size + ": " + el.value + " St\xFCck";
            }),
          noSize = document.getElementById("des-nosize-qty");
        noSize &&
          Number(noSize.value) > 0 &&
          quantities.push("Ohne Gr\xF6\xDFe: " + noSize.value + " St\xFCck");
        var rows = Math.ceil(captures.length / columns),
          tileW = 600,
          tileH = 640;
        ((canvas.width = columns * tileW),
          (canvas.height =
            180 + rows * tileH + Math.ceil(quantities.length / 3) * 30 + 70));
        var ctx = canvas.getContext("2d");
        return (
          (ctx.fillStyle = "#fff"),
          ctx.fillRect(0, 0, canvas.width, canvas.height),
          (ctx.fillStyle = "#171717"),
          (ctx.font = "bold 26px sans-serif"),
          ctx.fillText(
            "ALOE TEXTIL \xB7 Gestaltungs\xFCbersicht",
            28,
            42,
            canvas.width - 56,
          ),
          (ctx.font = "20px sans-serif"),
          ctx.fillText(
            S.product.title || "Dein Textil",
            28,
            80,
            canvas.width - 56,
          ),
          (ctx.font = "16px sans-serif"),
          ctx.fillText(
            "Farbe: " +
              displayColorName(S.selectedColor || "") +
              " \xB7 " +
              document.getElementById("des-method-select").selectedOptions[0]
                .textContent,
            28,
            110,
            canvas.width - 56,
          ),
          ctx.fillText(
            configurationId +
              " \xB7 Unverbindliche Vorschau, keine Produktionsfreigabe",
            28,
            140,
            canvas.width - 56,
          ),
          captures.forEach(function (capture, index) {
            var x = (index % columns) * tileW,
              y = 180 + Math.floor(index / columns) * tileH;
            ((ctx.fillStyle = "#f7f5f2"),
              ctx.fillRect(x + 12, y, tileW - 24, tileH - 12),
              (ctx.fillStyle = "#171717"),
              (ctx.font = "bold 20px sans-serif"),
              ctx.fillText(
                {
                  front: "Vorne",
                  back: "Hinten",
                  side: "Links",
                  side_r: "Rechts",
                }[capture.view],
                x + 28,
                y + 32,
              ));
            var scale = Math.min(
                (tileW - 40) / capture.image.width,
                (tileH - 68) / capture.image.height,
              ),
              w = capture.image.width * scale,
              h = capture.image.height * scale;
            ctx.drawImage(
              capture.image,
              x + (tileW - w) / 2,
              y + 50 + (tileH - 68 - h) / 2,
              w,
              h,
            );
          }),
          (ctx.fillStyle = "#171717"),
          (ctx.font = "16px sans-serif"),
          quantities.forEach(function (quantity, index) {
            ctx.fillText(
              quantity,
              28 + ((index % 3) * (canvas.width - 56)) / 3,
              180 + rows * tileH + 30 + Math.floor(index / 3) * 30,
              (canvas.width - 70) / 3,
            );
          }),
          new Promise(function (resolve, reject) {
            canvas.toBlob(function (blob) {
              if (!blob)
                return reject(
                  new Error(
                    "Gestaltungs\xFCbersicht konnte nicht gespeichert werden.",
                  ),
                );
              resolve(
                new File([blob], configurationId + "-alle-ansichten.png", {
                  type: "image/png",
                }),
              );
            }, "image/png");
          })
        );
      })
      .finally(function () {
        ((S.mockupView = originalView),
          S.mockupType && renderMockupMain(),
          loadViewLogo(originalView),
          (main.inert = !!S.saving),
          (S.exporting = !1));
      });
  }
  function exposeDesignerFileLinks(root, cartItem) {
    var properties = Object.assign({}, cartItem.properties || {}),
      originalUrl =
        typeof properties["Original-Logo"] == "string"
          ? properties["Original-Logo"]
          : "",
      previewUrl =
        typeof properties.Gestaltungsansicht == "string"
          ? properties.Gestaltungsansicht
          : "",
      editedUrl =
        typeof properties["Bearbeitetes-Logo"] == "string"
          ? properties["Bearbeitetes-Logo"]
          : "",
      links = {
        originalUrl: originalUrl,
        previewUrl: previewUrl,
        editedUrl: editedUrl,
      };
    return !originalUrl && !previewUrl && !editedUrl
      ? Promise.resolve(links)
      : (previewUrl && (properties["Designer-Mockup"] = previewUrl),
        originalUrl && (properties.Originaldatei = originalUrl),
        editedUrl && (properties["Bearbeitete Logodatei"] = editedUrl),
        fetch(root + "cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: cartItem.key,
            quantity: cartItem.quantity,
            properties: properties,
          }),
        })
          .then(function (response) {
            if (!response.ok)
              throw new Error(
                "Die Dateiverkn\xFCpfungen konnten nicht erg\xE4nzt werden.",
              );
            return response.json();
          })
          .then(function () {
            return links;
          })
          .catch(function (error) {
            return (
              console.warn(
                "[Aloe Designer] Quick-Quote-Dateilinks konnten nicht erg\xE4nzt werden.",
                error,
              ),
              links
            );
          }));
  }
  function addDesignerItems(items, baseProps, previewFile) {
    var root =
        (window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root) ||
        "/",
      designerFileLinks = null,
      editedFile = null;
    if (
      S.logoSrc !== S.logoOriginalSrc &&
      /^data:image\/png;base64,/.test(S.logoSrc)
    ) {
      for (
        var binary = atob(S.logoSrc.split(",")[1]),
          bytes = new Uint8Array(binary.length),
          i = 0;
        i < binary.length;
        i++
      )
        bytes[i] = binary.charCodeAt(i);
      editedFile = new File([bytes], "aloe-logo-bearbeitet.png", {
        type: "image/png",
      });
    }
    return items.reduce(function (chain, item, index) {
      return chain.then(function () {
        var formData = new FormData();
        return (
          formData.append("id", item.id),
          formData.append("quantity", item.quantity),
          Object.keys(baseProps).forEach(function (key) {
            formData.append("properties[" + key + "]", baseProps[key]);
          }),
          formData.append(
            "properties[Gr\xF6\xDFen]",
            item.size + ": " + item.quantity + " St\xFCck",
          ),
          index === 0
            ? (formData.append(
                "properties[Original-Logo]",
                S.logoFile,
                S.logoFile.name,
              ),
              editedFile &&
                formData.append(
                  "properties[Bearbeitetes-Logo]",
                  editedFile,
                  editedFile.name,
                ),
              previewFile &&
                formData.append(
                  "properties[Gestaltungsansicht]",
                  previewFile,
                  previewFile.name,
                ))
            : (formData.append(
                "properties[Logo-Datei]",
                "siehe erste Position dieser Konfiguration",
              ),
              designerFileLinks &&
                designerFileLinks.previewUrl &&
                formData.append(
                  "properties[Designer-Mockup]",
                  designerFileLinks.previewUrl,
                ),
              designerFileLinks &&
                designerFileLinks.originalUrl &&
                formData.append(
                  "properties[Originaldatei]",
                  designerFileLinks.originalUrl,
                ),
              designerFileLinks &&
                designerFileLinks.editedUrl &&
                formData.append(
                  "properties[Bearbeitete Logodatei]",
                  designerFileLinks.editedUrl,
                )),
          fetch(root + "cart/add.js", { method: "POST", body: formData }).then(
            function (response) {
              return response.json().then(function (data) {
                if (!response.ok || (data.status && data.status >= 400))
                  throw new Error(
                    data.description ||
                      "Die Konfiguration konnte nicht hinzugef\xFCgt werden.",
                  );
                return index === 0
                  ? exposeDesignerFileLinks(root, data).then(function (links) {
                      return ((designerFileLinks = links), data);
                    })
                  : data;
              });
            },
          )
        );
      });
    }, Promise.resolve());
  }
  function onSave() {
    if (!S.saving) {
      var invalid = invalidDesignerQuantity();
      if (invalid) {
        updateSummary(); invalid.focus(); invalid.reportValidity(); return;
      }
      var btn = document.getElementById("des-save-btn"),
        methodVal =
          (document.getElementById("des-method-select") || {}).value || "druck",
        method =
          methodVal === "stick"
            ? "Stickerei"
            : methodVal === "druck-stick"
              ? "Druck & Stickerei"
              : "Druck",
        items = [],
        baseVariant = findVariant(S.selectedColor);
      document.querySelectorAll(".des-size-qty").forEach(function (inp) {
        var qty = parseInt(inp.value) || 0;
        if (!(qty <= 0)) {
          var sizedVariant = findVariant(S.selectedColor, inp.dataset.size);
          sizedVariant &&
            items.push({
              id: sizedVariant.id,
              quantity: qty,
              size: inp.dataset.size,
            });
        }
      });
      var ns =
        parseInt((document.getElementById("des-nosize-qty") || {}).value) || 0;
      if (
        (ns > 0 &&
          baseVariant &&
          items.push({
            id: baseVariant.id,
            quantity: ns,
            size: "Ohne Gr\xF6\xDFe",
          }),
        !S.logoFile)
      ) {
        alert(
          "Bitte lade zuerst deine originale Logo-Datei hoch. Sie wird zusammen mit der Gestaltungsansicht an uns \xFCbermittelt.",
        );
        var uploadInput = document.getElementById("des-logo-input");
        uploadInput && uploadInput.click();
        return;
      }
      if (items.length === 0) {
        alert("Bitte geben Sie mindestens eine Menge an.");
        return;
      }
      var totalQty = items.reduce(function (s, it) {
        return s + it.quantity;
      }, 0);
      if (totalQty < DES_MIN_QTY) {
        alert(
          "Mindestbestellmenge: Bitte mindestens " +
            DES_MIN_QTY +
            " St\xFCck w\xE4hlen.\nGr\xF6\xDFen und Farben k\xF6nnen gemischt werden.\nAktuell: " +
            totalQty +
            " St\xFCck.",
        );
        return;
      }
      var originalButtonContent = btn.innerHTML;
      ((S.saving = !0),
        (document.querySelector("#aloe-designer-modal .des-main").inert = !0),
        (btn.disabled = !0),
        (btn.style.opacity = "0.6"),
        (btn.innerHTML = "<span>Dateien werden \xFCbertragen \u2026</span>"),
        saveViewLogo());
      var baseProps = { Veredelungsart: method };
      (S.selectedColor && (baseProps.Farbe = S.selectedColor),
        (baseProps.Logo = S.logoFile.name + " \xB7 Originaldatei beigef\xFCgt"),
        (baseProps["Konfigurations-ID"] =
          "ALOE-" + Date.now().toString(36).toUpperCase()));
      var placements = [];
      (Object.keys(S.viewLogos).forEach(function (view) {
        var logo = S.viewLogos[view];
        if (logo.active) {
          var label =
            { front: "Vorne", back: "Hinten", side: "Links", side_r: "Rechts" }[
              view
            ] || view;
          placements.push(
            label +
              " \xB7 X " +
              Math.round(logo.posX) +
              "% \xB7 Y " +
              Math.round(logo.posY) +
              "% \xB7 Gr\xF6\xDFe " +
              Math.round(logo.scale) +
              "% \xB7 Drehung " +
              Math.round(logo.rotation) +
              "\xB0",
          );
        }
      }),
        placements.length &&
          (baseProps["Logo-Positionen"] = placements.join(" | ")),
        (baseProps.Konfiguration = "Im Aloe Textil Designer erstellt"),
        createDesignerPreviewFile(baseProps["Konfigurations-ID"])
          .then(function (previewFile) {
            return addDesignerItems(items, baseProps, previewFile);
          })
          .then(function () {
            if (
              ((S.saving = !1),
              (document.querySelector("#aloe-designer-modal .des-main").inert =
                !1),
              (btn.disabled = !1),
              (btn.style.opacity = ""),
              (btn.innerHTML = originalButtonContent),
              UPSELL_FLOW.active)
            ) {
              window.location.assign(
                UPSELL_FLOW.returnTo + "?aloe_upsell_added=1",
              );
              return;
            }
            (closeDesigner(),
              document.dispatchEvent(new CustomEvent("cart:refresh")),
              document.dispatchEvent(
                new CustomEvent("aloe:designer-added", {
                  detail: {
                    productId: String(S.product.id || ""),
                    variantId: String((baseVariant && baseVariant.id) || ""),
                  },
                }),
              ));
            var trigger = document.querySelector(
              '[data-cart-toggle],.cart-toggle,#cart-icon-bubble,.js-cart-icon,[aria-label*="cart" i]',
            );
            trigger && trigger.click();
          })
          .catch(function (error) {
            ((S.saving = !1),
              (document.querySelector("#aloe-designer-modal .des-main").inert =
                !1),
              (btn.disabled = !1),
              (btn.style.opacity = ""),
              (btn.innerHTML = originalButtonContent),
              alert(
                "Die Dateien konnten nicht \xFCbertragen werden: " +
                  (error.message || "Bitte erneut versuchen."),
              ));
          }));
    }
  }
  function adoptProductSizeSelection() {
    if (!UPSELL_FLOW.active) {
      var scope = document.querySelector(
        '[data-aloe-inquiry-product] [id^="gsize-scope-"]',
      );
      if (scope) {
        var quantities = new Map();
        (scope
          .querySelectorAll(".gsize-input[data-size]")
          .forEach(function (input) {
            var quantity = Number(input.value);
            Number.isInteger(quantity) &&
              quantity >= 0 &&
              quantities.set(input.dataset.size, quantity);
          }),
          Array.from(quantities.values()).some(function (quantity) {
            return quantity > 0;
          }) &&
            (document
              .querySelectorAll(".des-size-qty[data-size]")
              .forEach(function (input) {
                quantities.has(input.dataset.size) &&
                  (input.value = quantities.get(input.dataset.size));
              }),
            updateSummary()));
      }
    }
  }
  function openDesigner() {
    var overlay = document.getElementById("aloe-designer-overlay");
    if (overlay) {
      if (!overlay.classList.contains("active")) {
        S.returnFocus = document.activeElement;
        S.previousOverflow = document.body.style.overflow;
      }
      overlay.inert = false;
      document.getElementById("des-close-btn").focus();
      if (
        (overlay.classList.add("active"),
        (document.body.style.overflow = "hidden"),
        S.editorOpened)
      ) {
        (S.mockupType && renderMockup(), loadViewLogo(S.mockupView));
        return;
      }
      ((S.editorOpened = !0),
        (S.logoScale = 18),
        (S.logoRotation = 0),
        (S.logoFlipH = !1),
        (S.mockupView = "front"),
        resetViewLogos(),
        updateZipperGuide());
      var flipBtn = document.getElementById("des-flip-h");
      flipBtn && flipBtn.classList.remove("is-active");
      var scaleSlider = document.getElementById("des-scale-slider");
      scaleSlider &&
        ((scaleSlider.value = 18),
        (document.getElementById("des-scale-val").textContent = "18%"));
      var rotVal = document.getElementById("des-rot-val");
      if (
        (rotVal && (rotVal.textContent = "0\xB0"),
        !S.mockupType && S.product && S.product.images && S.product.images[0])
      ) {
        var src = (S.product.images[0].src || S.product.images[0]).replace(
          /(\.[a-z]{2,4})(\?v=\d+)?$/i,
          "_800x$1$2",
        );
        setProductImage(src);
      }
      (readSwatchesFromDOM(),
        document
          .querySelectorAll(".des-color[data-value]")
          .forEach(function (btn) {
            var colorName = btn.getAttribute("data-value");
            btn.style.background = colorFromName(colorName);
          }),
        setTimeout(function () {
          var pageColor = getCurrentPageColor(),
            btn = null;
          (pageColor &&
            (btn = document.querySelector(
              '.des-color[data-value="' + pageColor.replace(/"/g, '\\"') + '"]',
            )),
            btn || (btn = document.querySelector(".des-color")),
            btn && ((S.selectedColor = null), btn.click()),
            adoptProductSizeSelection(),
            requestAnimationFrame(updateHandles),
            recordEdit());
        }, 60));
    }
  }
  function closeDesigner() {
    if (!(S.exporting || S.saving) && document.getElementById("aloe-designer-overlay").classList.contains("active")) {
      saveViewLogo();
      var overlay = document.getElementById("aloe-designer-overlay");
      (overlay && overlay.classList.remove("active"),
        (document.body.style.overflow = S.previousOverflow || ""));
      overlay.inert = true;
      if (location.hash === "#aloe-designer-overlay") history.replaceState(null, "", location.pathname + location.search);
      if (S.returnFocus && S.returnFocus.isConnected) S.returnFocus.focus();
    }
  }
  function saveViewLogo() {
    var vl = S.viewLogos[S.mockupView];
    vl.active &&
      ((vl.posX = S.logoPosX),
      (vl.posY = S.logoPosY),
      (vl.scale = S.logoScale),
      (vl.rotation = S.logoRotation),
      (vl.flipH = S.logoFlipH),
      updateThumbBadges());
  }
  function loadViewLogo(view) {
    var vl = S.viewLogos[view],
      logoEl = document.getElementById("des-logo-overlay"),
      handles = document.getElementById("des-logo-handles"),
      toolbar = document.getElementById("des-logo-toolbar");
    if (!S.logoSrc || !vl.active) {
      (logoEl && logoEl.classList.remove("visible"),
        handles && handles.classList.remove("visible"),
        toolbar && toolbar.classList.remove("visible"),
        updateZipperGuide(),
        updateLogoThumbHint());
      return;
    }
    var flipBtn = document.getElementById("des-flip-h"),
      sl = document.getElementById("des-scale-slider"),
      rv = document.getElementById("des-rot-val");
    ((S.logoPosX = vl.posX),
      (S.logoPosY = vl.posY),
      (S.logoScale = vl.scale),
      (S.logoRotation = vl.rotation),
      (S.logoFlipH = vl.flipH),
      flipBtn && flipBtn.classList.toggle("is-active", S.logoFlipH),
      sl &&
        ((sl.value = Math.round(S.logoScale)),
        (document.getElementById("des-scale-val").textContent =
          Math.round(S.logoScale) + "%")),
      rv && (rv.textContent = Math.round(S.logoRotation) + "\xB0"),
      logoEl && logoEl.classList.add("visible"),
      handles && handles.classList.add("visible"),
      toolbar && toolbar.classList.add("visible"),
      applyLogoTransform(),
      updateLogoThumbHint());
  }
  function updateLogoThumbHint() {
    var hint = document.getElementById("des-logo-add-hint");
    if (hint) {
      var vl = S.viewLogos[S.mockupView],
        showHint = !!(S.logoSrc && S.mockupType && !vl.active);
      hint.style.display = showHint ? "" : "none";
    }
  }
  function placeLogoOnCurrentView() {
    if (S.logoSrc) {
      var vl = S.viewLogos[S.mockupView];
      ((vl.active = !0),
        (S.logoPosX = 52),
        (S.logoPosY = 38),
        (S.logoScale = 18),
        (S.logoRotation = 0),
        (S.logoFlipH = !1),
        (vl.posX = 52),
        (vl.posY = 38),
        (vl.scale = 18),
        (vl.rotation = 0),
        (vl.flipH = !1));
      var logoEl = document.getElementById("des-logo-overlay"),
        handles = document.getElementById("des-logo-handles"),
        toolbar = document.getElementById("des-logo-toolbar"),
        flipBtn = document.getElementById("des-flip-h"),
        sl = document.getElementById("des-scale-slider"),
        rv = document.getElementById("des-rot-val");
      (logoEl && logoEl.classList.add("visible"),
        handles && handles.classList.add("visible"),
        toolbar && toolbar.classList.add("visible"),
        flipBtn && flipBtn.classList.remove("is-active"),
        sl &&
          ((sl.value = 18),
          (document.getElementById("des-scale-val").textContent = "18%")),
        rv && (rv.textContent = "0\xB0"),
        applyLogoTransform(),
        updateThumbBadges(),
        updateLogoThumbHint());
    }
  }
  function updateThumbBadges() {
    document.querySelectorAll(".des-mt-wrap").forEach(function (wrap) {
      var v = wrap.dataset.view;
      wrap.classList.toggle(
        "has-logo",
        !!(S.logoSrc && S.viewLogos[v] && S.viewLogos[v].active),
      );
    });
  }
  function resetViewLogos() {
    S.viewLogos = {
      front: {
        posX: 52,
        posY: 38,
        scale: 18,
        rotation: 0,
        flipH: !1,
        active: !1,
      },
      back: {
        posX: 52,
        posY: 38,
        scale: 18,
        rotation: 0,
        flipH: !1,
        active: !1,
      },
      side: {
        posX: 52,
        posY: 38,
        scale: 18,
        rotation: 0,
        flipH: !1,
        active: !1,
      },
      side_r: {
        posX: 52,
        posY: 38,
        scale: 18,
        rotation: 0,
        flipH: !1,
        active: !1,
      },
    };
  }
  function downloadPreview() {
    var productImg = document.getElementById("des-product-img"),
      logoOverlay = document.getElementById("des-logo-overlay"),
      wrap = document.getElementById("des-product-wrap");
    if (!(!productImg || !productImg.src || !wrap)) {
      var prodR = productImg.getBoundingClientRect(),
        canvas = document.createElement("canvas");
      ((canvas.width = prodR.width), (canvas.height = prodR.height));
      var ctx = canvas.getContext("2d"),
        pImg = new Image();
      ((pImg.crossOrigin = "anonymous"),
        (pImg.onload = function () {
          if (
            (ctx.drawImage(pImg, 0, 0, canvas.width, canvas.height),
            logoOverlay &&
              logoOverlay.classList.contains("visible") &&
              S.logoSrc)
          ) {
            var logoR = logoOverlay.getBoundingClientRect(),
              lx = logoR.left - prodR.left + logoR.width / 2,
              ly = logoR.top - prodR.top + logoR.height / 2,
              lImg = new Image();
            ((lImg.onload = function () {
              (ctx.save(),
                ctx.translate(lx, ly),
                ctx.rotate((S.logoRotation * Math.PI) / 180),
                S.logoFlipH && ctx.scale(-1, 1),
                ctx.drawImage(
                  lImg,
                  -logoOverlay.offsetWidth / 2,
                  -logoOverlay.offsetHeight / 2,
                  logoOverlay.offsetWidth,
                  logoOverlay.offsetHeight,
                ),
                ctx.restore(),
                triggerDownload(canvas));
            }),
              (lImg.src = S.logoSrc));
          } else triggerDownload(canvas);
        }),
        (pImg.onerror = function () {
          alert("Vorschau konnte nicht erstellt werden (CORS).");
        }),
        (pImg.src = productImg.src));
    }
  }
  function triggerDownload(canvas) {
    var a = document.createElement("a");
    ((a.download = "aloe-vorschau.png"),
      (a.href = canvas.toDataURL("image/png")),
      a.click());
  }
  function bindEvents() {
    var overlay = document.getElementById("aloe-designer-overlay");
    (document
      .getElementById("des-close-btn")
      .addEventListener("click", closeDesigner),
      overlay.addEventListener("click", function (e) {
        e.target === this && closeDesigner();
      }),
      document.addEventListener("keydown", function (e) {
        e.key === "Escape" && closeDesigner();
      }),
      document
        .getElementById("des-logo-input")
        .addEventListener("change", onLogoUpload),
      document
        .getElementById("des-logo-add-hint")
        .addEventListener("click", placeLogoOnCurrentView),
      document
        .getElementById("des-remove-bg")
        .addEventListener("click", removeLogoBackground),
      document
        .getElementById("des-crop-logo")
        .addEventListener("click", function () {
          editLogoPixels("crop");
        }),
      document
        .getElementById("des-ink-black")
        .addEventListener("click", function () {
          editLogoPixels("black");
        }),
      document
        .getElementById("des-ink-white")
        .addEventListener("click", function () {
          editLogoPixels("white");
        }),
      document
        .getElementById("des-restore-logo")
        .addEventListener("click", function () {
          S.logoOriginalSrc &&
            (setLogoImageSource(S.logoOriginalSrc),
            setLogoEditStatus("Original wiederhergestellt."));
        }));
    var logoEl = document.getElementById("des-logo-overlay");
    (logoEl.addEventListener("pointerdown", startDrag),
      document.addEventListener("pointermove", moveDrag),
      document.addEventListener("pointerup", stopDrag),
      document.querySelectorAll(".des-lh").forEach(function (h) {
        h.addEventListener("pointerdown", startHandleAction);
      }),
      window.addEventListener("pointermove", onHandleMove, { passive: !1 }),
      window.addEventListener("pointerup", stopHandleAction),
      window.addEventListener("pointercancel", stopHandleAction),
      document
        .getElementById("des-product-wrap")
        .addEventListener("click", onWrapClick),
      document
        .getElementById("des-thumbs")
        .addEventListener("click", function (e) {
          var wrap = e.target.closest ? e.target.closest(".des-mt-wrap") : null;
          if (wrap) {
            (saveViewLogo(),
              document.querySelectorAll(".des-mt-wrap").forEach(function (w) {
                w.classList.remove("active");
              }),
              wrap.classList.add("active"),
              (S.mockupView = wrap.dataset.view),
              renderMockupMain(),
              loadViewLogo(S.mockupView));
            return;
          }
          e.target.classList.contains("des-thumb") &&
            (document.querySelectorAll(".des-thumb").forEach(function (t) {
              t.classList.remove("active");
            }),
            e.target.classList.add("active"),
            setProductImage(e.target.dataset.full));
        }),
      overlay.addEventListener("click", function (e) {
        if (e.target.classList.contains("des-color")) {
          (document.querySelectorAll(".des-color").forEach(function (b) {
            b.classList.remove("active");
          }),
            e.target.classList.add("active"),
            (S.selectedColor = e.target.dataset.value));
          var lbl = document.getElementById("des-color-label");
          (lbl && (lbl.textContent = displayColorName(S.selectedColor)),
            S.mockupType ? renderMockup() : updateVariantImage(),
            updateSummary());
        }
      }),
      overlay.addEventListener("input", function (e) {
        (e.target.classList.contains("des-size-qty") ||
          e.target.id === "des-nosize-qty") &&
          updateSummary();
      }),
      document
        .getElementById("des-scale-slider")
        .addEventListener("input", function () {
          ((S.logoScale = parseInt(this.value)),
            (document.getElementById("des-scale-val").textContent =
              S.logoScale + "%"),
            applyLogoTransform());
        }),
      document
        .getElementById("des-rot-left")
        .addEventListener("click", function () {
          ((S.logoRotation = (S.logoRotation - 15 + 360) % 360),
            (document.getElementById("des-rot-val").textContent =
              S.logoRotation + "\xB0"),
            applyLogoTransform());
        }),
      document
        .getElementById("des-rot-right")
        .addEventListener("click", function () {
          ((S.logoRotation = (S.logoRotation + 15) % 360),
            (document.getElementById("des-rot-val").textContent =
              S.logoRotation + "\xB0"),
            applyLogoTransform());
        }),
      document
        .getElementById("des-flip-h")
        .addEventListener("click", function () {
          ((S.logoFlipH = !S.logoFlipH),
            this.classList.toggle("is-active", S.logoFlipH),
            applyLogoTransform());
        }),
      document
        .getElementById("des-center-btn")
        .addEventListener("click", function () {
          ((S.logoPosX = 52), (S.logoPosY = 38), applyLogoTransform());
        }),
      document.querySelectorAll(".des-pos-btn").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          (e.stopPropagation(),
            (S.logoPosX = parseFloat(this.dataset.x)),
            (S.logoPosY = parseFloat(this.dataset.y)),
            applyLogoTransform());
        });
      }),
      document
        .getElementById("des-dl-btn")
        .addEventListener("click", downloadPreview),
      document.addEventListener("keydown", function (e) {
        var overlay2 = document.getElementById("aloe-designer-overlay");
        if (
          !(!overlay2 || !overlay2.classList.contains("active")) &&
          !(
            e.target.tagName === "INPUT" ||
            e.target.tagName === "SELECT" ||
            e.target.tagName === "TEXTAREA"
          ) &&
          S.logoSrc
        ) {
          var changed = !0;
          switch (e.key) {
            case "ArrowLeft":
              S.logoPosX = Math.max(2, S.logoPosX - 1);
              break;
            case "ArrowRight":
              S.logoPosX = Math.min(98, S.logoPosX + 1);
              break;
            case "ArrowUp":
              S.logoPosY = Math.max(2, S.logoPosY - 1);
              break;
            case "ArrowDown":
              S.logoPosY = Math.min(98, S.logoPosY + 1);
              break;
            case "+":
            case "=":
              S.logoScale = Math.min(150, S.logoScale + 2);
              break;
            case "-":
            case "_":
              S.logoScale = Math.max(4, S.logoScale - 2);
              break;
            case "f":
            case "F":
              S.logoFlipH = !S.logoFlipH;
              break;
            case "c":
            case "C":
              ((S.logoPosX = 52), (S.logoPosY = 38));
              break;
            default:
              changed = !1;
          }
          changed && (e.preventDefault(), applyLogoTransform());
        }
      }),
      document
        .getElementById("des-logo-reset")
        .addEventListener("click", function () {
          ((S.logoSrc = null),
            (S.logoOriginalSrc = null),
            (S.logoFile = null),
            (S.logoNatW = 0),
            (S.logoNatH = 0),
            (S.logoScale = 18),
            (S.logoRotation = 0),
            (S.logoFlipH = !1),
            resetViewLogos());
          var flipBtn = document.getElementById("des-flip-h");
          flipBtn && flipBtn.classList.remove("is-active");
          var logoEl2 = document.getElementById("des-logo-overlay");
          (logoEl2.removeAttribute("src"),
            logoEl2.classList.remove("visible"),
            document
              .getElementById("des-logo-handles")
              .classList.remove("visible"),
            document
              .getElementById("des-logo-thumb")
              .classList.remove("visible"),
            document
              .getElementById("des-upload-btn")
              .classList.remove("has-logo"),
            document
              .getElementById("des-logo-edit-actions")
              .classList.remove("visible"),
            document
              .getElementById("des-logo-toolbar")
              .classList.remove("visible"),
            (document.getElementById("des-drop-hint").style.display = ""),
            (document.getElementById("des-dpi-badge").style.display = "none"),
            (document.getElementById("des-logo-input").value = ""),
            updateThumbBadges(),
            updateLogoThumbHint());
        }),
      document.getElementById("des-save-btn").addEventListener("click", onSave),
      document
        .getElementById("des-help-btn")
        .addEventListener("click", function () {
          alert(
            'So verwenden Sie den Konfigurator:\n\n1. Klicken Sie auf "Logo hochladen" (PNG, JPG oder SVG)\n2. Klicken Sie auf das Produkt um das Logo zu platzieren\n3. Logo verschieben: Direkt am Logo ziehen\n4. Logo skalieren: Einen pinken Eckgriff direkt am Logo ziehen\n5. Logo drehen: Den runden Griff \xFCber dem Logo ziehen\n6. Alternativ Gr\xF6\xDFe und Drehung oben in der Werkzeugleiste einstellen\n7. Farbe w\xE4hlen \u2014 das Shirt f\xE4rbt sich ein\n8. Mengen pro Gr\xF6\xDFe eingeben\n9. "Konfiguration speichern" klicken',
          );
        }),
      window.addEventListener("resize", function () {
        requestAnimationFrame(updateHandles);
      }));
  }
  function insertButton() {
    var container =
      document.querySelector(
        ".product__info-wrapper_3nd_grid_item .product__info-container",
      ) || document.querySelector(".product__info-wrapper_3nd_grid_item");
    if (!container) {
      var anchor =
        document.querySelector(".product-form__buttons") ||
        document.querySelector('form[action="/cart/add"]') ||
        document.querySelector(".product__info-container");
      if (!anchor) return;
      container =
        anchor.closest(".product__info-container") || anchor.parentElement;
    }
    var wrap = document.createElement("div");
    ((wrap.className = "aloe-design-cta"),
      (wrap.innerHTML =
        '<div class="aloe-design-cta__copy"><strong>Logo direkt ansehen</strong><span>Unverbindliche Vorschau auf deinem Textil</span></div><a href="#aloe-designer-overlay" class="aloe-design-btn" id="aloe-design-btn"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg><span>Jetzt gestalten</span><b aria-hidden="true">\u2192</b></a>'),
      container.insertBefore(wrap, container.firstChild));
  }
  function initTeamList() {
    if (document.getElementById("aloe-team-list")) return;
    var anchor = document.querySelector(".aloe-design-cta");
    if (!anchor) return;
    var trigger = document.createElement("button");
    ((trigger.type = "button"),
      (trigger.className = "aloe-team-trigger"),
      (trigger.textContent = "F\xFCr Vereine & Firmen: Team-Bestellliste"),
      anchor.insertAdjacentElement("afterend", trigger));
    var dialog = document.createElement("dialog");
    ((dialog.id = "aloe-team-list"),
      dialog.setAttribute("aria-labelledby", "team-title"),
      (dialog.innerHTML =
        '<header><div><small>GEMEINSAM BESTELLEN</small><h2 id="team-title">Eine Liste f\xFCr dein Team</h2></div><button type="button" data-team="close" aria-label="Team-Bestellliste schlie\xDFen">\xD7</button></header><div class="team-body"><div class="team-steps"><div class="team-step"><span class="team-step-number">1</span><div><strong>Artikel ausgew\xE4hlt</strong><p id="team-article-name"></p><a href="/collections/all">Anderen Artikel ausw\xE4hlen</a></div></div><div class="team-step"><span class="team-step-number">2</span><div><label for="team-default-color"><strong>Farbe f\xFCr das Team w\xE4hlen</strong></label><select id="team-default-color"></select><label class="team-mixed-choice"><input id="team-mixed-colors" type="checkbox"> Unterschiedliche Farben pro Person</label></div></div><div class="team-step"><span class="team-step-number">3</span><div><strong>Gr\xF6\xDFen und St\xFCckzahlen eintragen</strong><p>Name oder K\xFCrzel ist optional. Die gew\xE4hlte Farbe gilt f\xFCr alle Zeilen, sofern du nicht mehrere Farben aktivierst.</p></div></div></div><div class="team-list-heading"><strong>Personenliste</strong><button type="button" data-team="add">+ Person</button></div><div class="team-table-wrap"><table class="team-table"><thead><tr><th>Nr.</th><th>Name / K\xFCrzel</th><th>Farbe</th><th>Gr\xF6\xDFe</th><th>St\xFCck</th><th><span class="visually-hidden">Entfernen</span></th></tr></thead><tbody id="team-rows"></tbody></table></div><div class="team-actions"><button type="button" data-team="fifty">Auf 50 Zeilen erg\xE4nzen</button><button type="button" data-team="save">Im Browser speichern</button><button type="button" data-team="load">Gespeicherte Liste laden</button></div><label class="team-org">Verein / Firma (optional)<input id="team-org" maxlength="120" autocomplete="organization"></label><p class="team-privacy">Namen oder K\xFCrzel reichen. Kein automatischer Versand. Speichern nur auf diesem Ger\xE4t \u2013 auf gemeinsam genutzten Ger\xE4ten danach l\xF6schen.</p><section class="team-summary" aria-label="Mengenzusammenfassung"><h3>Deine Gr\xF6\xDFenliste</h3><p id="team-total" aria-live="polite"></p><div id="team-groups"></div></section><section class="team-bundle" aria-label="Gemeinsame Sammelliste"><h3>Mehrere Artikel in einer Liste</h3><p>\xDCbernimm diesen Artikel mit seinen Farben und Gr\xF6\xDFen. \xD6ffne danach ein weiteres Produkt und erg\xE4nze es dort zur selben Sammelliste.</p><div class="team-actions"><button type="button" class="team-bundle-add" data-team="bundle-add">Diesen Artikel zur Sammelliste hinzuf\xFCgen</button><a class="team-catalog-link" href="/collections/all">Weiteren Artikel ausw\xE4hlen \u2192</a></div><div id="team-bundle-items" aria-live="polite"></div><div class="team-actions team-bundle-export"><button type="button" data-team="bundle-print">Sammelliste drucken / PDF</button><button type="button" data-team="bundle-download">Sammelliste als Text</button><button type="button" data-team="bundle-clear">Sammelliste l\xF6schen</button></div></section><p id="team-status" role="status"></p><p class="team-privacy">Die Auswahl stammt aus diesem Produkt. Bei separat gepflegten Gr\xF6\xDFen ist die Lieferbarkeit je Farbe/Gr\xF6\xDFe erst mit unserem Angebot best\xE4tigt. Diese Liste ist noch keine Bestellung.</p><div class="team-actions team-export"><button type="button" data-team="print">Ausgef\xFCllte Liste drucken / PDF</button><button type="button" data-team="blank">Blankoliste zum Ankreuzen</button><button type="button" data-team="download">Liste als Text herunterladen</button></div><p>\xDCbergabe: PDF oder Textdatei mit deiner Anfrage an <a href="mailto:info@aloe-gmbh.de">info@aloe-gmbh.de</a> senden. Papierlisten kannst du uns auch pers\xF6nlich \xFCberreichen. Ein PDF speicherst du im Druckdialog mit \u201EAls PDF sichern\u201C.</p><button type="button" class="team-clear" data-team="clear">Diese Artikelliste und lokale Speicherung l\xF6schen</button></div>'),
      document.body.appendChild(dialog));
    var rows = [],
      teamColor = "",
      mixedColors = !1,
      key = "aloe-team-list-v1-" + S.product.id,
      bundleKey = "aloe-team-bundle-v1",
      bundle = { org: "", items: [] },
      opts = S.product.options_with_values || S.product.options || [],
      ci = opts.findIndex(function (o) {
        return /farbe|colou?r/i.test(o.name || o);
      }),
      si = getSizeOptionIndex();
    function option(v, i) {
      return i < 0
        ? ""
        : String(v["option" + (i + 1)] || (v.options || [])[i] || "");
    }
    function unique(values) {
      return Array.from(new Set(values.filter(Boolean)));
    }
    var available = S.variants.filter(function (v) {
        return v.available !== !1;
      }),
      colors =
        ci < 0
          ? ["Standard"]
          : unique(
              available.map(function (v) {
                return option(v, ci);
              }),
            );
    teamColor =
      colors.indexOf(getCurrentPageColor()) >= 0
        ? getCurrentPageColor()
        : colors.length === 1
          ? colors[0]
          : "";
    function sizes(color) {
      if (si >= 0)
        return unique(
          available
            .filter(function (v) {
              return ci < 0 || option(v, ci) === color;
            })
            .map(function (v) {
              return option(v, si);
            }),
        );
      var stored = getProductSizes();
      return stored.length ? stored : ["Gr\xF6\xDFe mit uns kl\xE4ren"];
    }
    function esc2(value) {
      return String(value == null ? "" : value).replace(
        /[&<>"']/g,
        function (c) {
          return {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;",
          }[c];
        },
      );
    }
    function status(message) {
      dialog.querySelector("#team-status").textContent = message;
    }
    function selected(values, value, placeholder) {
      return (
        '<option value="">' +
        placeholder +
        "</option>" +
        values
          .map(function (v) {
            return (
              '<option value="' +
              esc2(v) +
              '"' +
              (v === value ? " selected" : "") +
              ">" +
              esc2(v) +
              "</option>"
            );
          })
          .join("")
      );
    }
    function add() {
      rows.push({ name: "", color: teamColor, size: "", qty: "" });
    }
    function valid(row) {
      return (
        colors.indexOf(row.color) >= 0 &&
        sizes(row.color).indexOf(row.size) >= 0 &&
        Number.isInteger(Number(row.qty)) &&
        Number(row.qty) > 0 &&
        Number(row.qty) <= 999
      );
    }
    function used(row) {
      return !!(row.name || row.size || row.qty);
    }
    function groups() {
      var data = new Map();
      return (
        rows.filter(valid).forEach(function (row) {
          var k = JSON.stringify([row.color, row.size]);
          data.set(k, (data.get(k) || 0) + Number(row.qty));
        }),
        Array.from(data.entries()).map(function (entry) {
          var pair = JSON.parse(entry[0]);
          return { color: pair[0], size: pair[1], qty: entry[1] };
        })
      );
    }
    function summary() {
      var complete = rows.filter(valid),
        pending = rows.filter(function (r) {
          return used(r) && !valid(r);
        }).length;
      ((dialog.querySelector("#team-total").textContent =
        complete.reduce(function (n, r) {
          return n + Number(r.qty);
        }, 0) +
        " St\xFCck \xB7 " +
        complete.length +
        " vollst\xE4ndige Zeilen" +
        (pending
          ? " \xB7 " + pending + " unvollst\xE4ndig (nicht mitgez\xE4hlt)"
          : "")),
        (dialog.querySelector("#team-groups").innerHTML = groups()
          .map(function (g) {
            return (
              "<span>" +
              esc2(g.color) +
              " \xB7 " +
              esc2(g.size) +
              ": <b>" +
              g.qty +
              " St\xFCck</b></span>"
            );
          })
          .join("")));
    }
    function loadBundle() {
      try {
        var saved = JSON.parse(localStorage.getItem(bundleKey));
        saved &&
          Array.isArray(saved.items) &&
          (bundle = {
            org: String(saved.org || "").slice(0, 120),
            items: saved.items
              .slice(0, 20)
              .filter(function (item) {
                return (
                  item &&
                  /^\/products\/[a-z0-9-]+$/i.test(String(item.path || "")) &&
                  Array.isArray(item.rows)
                );
              })
              .map(function (item) {
                return {
                  id: String(item.id || ""),
                  title: String(item.title || "").slice(0, 180),
                  path: String(item.path),
                  rows: item.rows
                    .slice(0, 200)
                    .map(function (r) {
                      return {
                        name: String(r.name || "").slice(0, 80),
                        color: String(r.color || "").slice(0, 100),
                        size: String(r.size || "").slice(0, 60),
                        qty: Number(r.qty) || 0,
                      };
                    })
                    .filter(function (r) {
                      return (
                        Number.isInteger(r.qty) && r.qty > 0 && r.qty <= 999
                      );
                    }),
                };
              }),
          });
      } catch (e) {
        bundle = { org: "", items: [] };
      }
    }
    function saveBundle() {
      try {
        return (localStorage.setItem(bundleKey, JSON.stringify(bundle)), !0);
      } catch (e) {
        return (
          status(
            "Sammelliste konnte hier nicht gespeichert werden. Bitte Browser-Speicher pr\xFCfen.",
          ),
          !1
        );
      }
    }
    function bundleGroups(item) {
      var data = new Map();
      return (
        (item.rows || []).forEach(function (r) {
          var k = JSON.stringify([r.color, r.size]);
          data.set(k, (data.get(k) || 0) + Number(r.qty));
        }),
        Array.from(data.entries()).map(function (entry) {
          var pair = JSON.parse(entry[0]);
          return { color: pair[0], size: pair[1], qty: entry[1] };
        })
      );
    }
    function bundleTotal(item) {
      return (item.rows || []).reduce(function (n, r) {
        return n + Number(r.qty);
      }, 0);
    }
    function renderBundle() {
      var target = dialog.querySelector("#team-bundle-items");
      if (!bundle.items.length) {
        target.innerHTML =
          '<p class="team-bundle-empty">Noch kein Artikel \xFCbernommen.</p>';
        return;
      }
      target.innerHTML = bundle.items
        .map(function (item, i) {
          return (
            '<article class="team-bundle-item"><div><strong>' +
            esc2(item.title) +
            "</strong><span>" +
            bundleTotal(item) +
            " St\xFCck</span></div><p>" +
            bundleGroups(item)
              .map(function (g) {
                return (
                  esc2(g.color) +
                  " \xB7 " +
                  esc2(g.size) +
                  ": " +
                  g.qty +
                  " St\xFCck"
                );
              })
              .join(" \xB7 ") +
            '</p><div><a href="' +
            esc2(item.path) +
            '">Artikel \xF6ffnen</a><button type="button" data-bundle-remove="' +
            i +
            '" aria-label="' +
            esc2(item.title) +
            ' aus Sammelliste entfernen">Entfernen</button></div></article>'
          );
        })
        .join("");
    }
    function render() {
      (dialog.classList.toggle("team-mixed", mixedColors),
        (dialog.querySelector("#team-default-color").innerHTML = selected(
          colors,
          teamColor,
          "Farbe w\xE4hlen",
        )),
        (dialog.querySelector("#team-mixed-colors").checked = mixedColors),
        (dialog.querySelector("#team-article-name").textContent =
          S.product.title),
        (dialog.querySelector("#team-rows").innerHTML = rows
          .map(function (r, i) {
            return (
              '<tr data-row="' +
              i +
              '"><td>' +
              (i + 1) +
              '</td><td><input data-field="name" aria-label="Name Zeile ' +
              (i + 1) +
              '" maxlength="80" value="' +
              esc2(r.name) +
              '" placeholder="Name / K\xFCrzel"></td><td><select data-field="color" aria-label="Farbe Zeile ' +
              (i + 1) +
              '">' +
              selected(colors, r.color, "Farbe w\xE4hlen") +
              '</select></td><td><select data-field="size" aria-label="Gr\xF6\xDFe Zeile ' +
              (i + 1) +
              '">' +
              selected(
                r.color ? sizes(r.color) : [],
                r.size,
                "Gr\xF6\xDFe w\xE4hlen",
              ) +
              '</select></td><td><input data-field="qty" aria-label="St\xFCckzahl Zeile ' +
              (i + 1) +
              '" type="number" placeholder="St\xFCck" min="1" max="999" step="1" inputmode="numeric" value="' +
              esc2(r.qty) +
              '"></td><td><button type="button" data-remove="' +
              i +
              '" aria-label="Zeile ' +
              (i + 1) +
              ' entfernen">\xD7</button></td></tr>'
            );
          })
          .join("")),
        summary(),
        renderBundle());
    }
    function print(blank) {
      if (
        !blank &&
        rows.some(function (r) {
          return used(r) && !valid(r);
        })
      ) {
        status(
          "Bitte erst alle begonnenen Zeilen vervollst\xE4ndigen oder entfernen.",
        );
        return;
      }
      var outputRows = blank ? rows : rows.filter(valid);
      if (!outputRows.length) {
        status(
          "Bitte erst mindestens eine vollst\xE4ndige Zeile ausf\xFCllen.",
        );
        return;
      }
      var allSizes = unique(
          colors.reduce(function (a, c) {
            return a.concat(sizes(c));
          }, []),
        ),
        org = dialog.querySelector("#team-org").value,
        html =
          '<!doctype html><html lang="de"><head><meta charset="utf-8"><title>Team-Bestellliste \u2013 Aloe Textil</title><style>@page{size:A4;margin:14mm}body{font:11px Arial,sans-serif;color:#171717}h1{font-size:22px}table{border-collapse:collapse;width:100%;margin:16px 0}th,td{border:1px solid #aaa;padding:7px;text-align:left}tr{break-inside:avoid}thead{display:table-header-group}small{font-size:10px}.check{white-space:nowrap;display:inline-block;margin:3px}a{color:inherit;word-break:break-all}</style></head><body><h1>Team-Bestellliste</h1><h2>' +
          esc2(S.product.title) +
          "</h2><p>Verein / Firma: " +
          (esc2(org) || "________________________________") +
          "</p><p>Artikelnummer(n): " +
          esc2(
            unique(
              S.variants.map(function (v) {
                return v.sku;
              }),
            )
              .slice(0, 3)
              .join(", ") || "siehe Produktlink",
          ) +
          " (Referenzvarianten; Zuordnung \xFCber Produkt, Farbe und Gr\xF6\xDFe)</p><p>Produkt: " +
          esc2(location.origin + location.pathname) +
          "</p><p>Farben: " +
          esc2(colors.join(" \xB7 ")) +
          "</p><p>Gr\xF6\xDFen: " +
          esc2(allSizes.join(" \xB7 ")) +
          "</p><table><thead><tr><th>Nr.</th><th>Name / K\xFCrzel</th><th>Farbe</th><th>Gr\xF6\xDFe</th><th>St\xFCck</th></tr></thead><tbody>" +
          outputRows
            .map(function (r, i) {
              var checks = allSizes
                .map(function (s) {
                  return '<span class="check">\u25A1 ' + esc2(s) + "</span>";
                })
                .join(" ");
              return (
                "<tr><td>" +
                (i + 1) +
                '</td><td style="min-width:30mm">' +
                (blank ? "________________" : esc2(r.name)) +
                "</td><td>" +
                (blank ? "__________" : esc2(r.color)) +
                "</td><td>" +
                (blank ? checks : esc2(r.size)) +
                "</td><td>" +
                (blank ? "____" : r.qty) +
                "</td></tr>"
              );
            })
            .join("") +
          "</tbody></table>" +
          (blank
            ? ""
            : "<h2>Mengenzusammenfassung</h2><p>" +
              groups()
                .map(function (g) {
                  return esc2(g.color) + " / " + esc2(g.size) + ": " + g.qty;
                })
                .join(" \xB7 ") +
              "</p><b>Gesamt: " +
              rows.filter(valid).reduce(function (n, r) {
                return n + Number(r.qty);
              }, 0) +
              " St\xFCck</b>") +
          "<p>Veredelung / Logo / Hinweise: __________________________________________________</p><p>Kontakt f\xFCr R\xFCckfragen: _______________________________________________________</p><p>Liste an info@aloe-gmbh.de senden oder pers\xF6nlich \xFCberreichen. Noch keine Bestellung; Verf\xFCgbarkeit und Ausf\xFChrung best\xE4tigen wir im Angebot.</p></body></html>",
        old = document.getElementById("aloe-team-print");
      old && old.remove();
      var frame = document.createElement("iframe");
      ((frame.id = "aloe-team-print"),
        (frame.title = "Druckansicht Team-Bestellliste"),
        (frame.style.cssText =
          "position:fixed;width:1px;height:1px;left:-10000px;border:0"),
        (frame.onload = function () {
          (frame.contentWindow.focus(), frame.contentWindow.print());
        }),
        (frame.srcdoc = html),
        document.body.appendChild(frame),
        status("Im Druckdialog kannst du drucken oder als PDF speichern."));
    }
    function printBundle() {
      if (!bundle.items.length) {
        status(
          "Bitte zuerst mindestens einen Artikel zur Sammelliste hinzuf\xFCgen.",
        );
        return;
      }
      var lines = bundle.items.reduce(function (all, item) {
          return all.concat(
            item.rows.map(function (r) {
              return {
                title: item.title,
                name: r.name,
                color: r.color,
                size: r.size,
                qty: r.qty,
              };
            }),
          );
        }, []),
        html =
          '<!doctype html><html lang="de"><head><meta charset="utf-8"><title>Team-Sammelliste \u2013 Aloe Textil</title><style>@page{size:A4;margin:14mm}body{font:11px Arial,sans-serif;color:#171717}h1{font-size:22px}table{border-collapse:collapse;width:100%;margin:16px 0}th,td{border:1px solid #aaa;padding:7px;text-align:left}tr{break-inside:avoid}thead{display:table-header-group}</style></head><body><h1>Team-Sammelliste</h1><p>Verein / Firma: ' +
          esc2(bundle.org || "________________________________") +
          "</p><table><thead><tr><th>Artikel</th><th>Name / K\xFCrzel</th><th>Farbe</th><th>Gr\xF6\xDFe</th><th>St\xFCck</th></tr></thead><tbody>" +
          lines
            .map(function (r) {
              return (
                "<tr><td>" +
                esc2(r.title) +
                "</td><td>" +
                esc2(r.name) +
                "</td><td>" +
                esc2(r.color) +
                "</td><td>" +
                esc2(r.size) +
                "</td><td>" +
                r.qty +
                "</td></tr>"
              );
            })
            .join("") +
          "</tbody></table><h2>Zusammenfassung</h2>" +
          bundle.items
            .map(function (item) {
              return (
                "<p><strong>" +
                esc2(item.title) +
                " \u2013 " +
                bundleTotal(item) +
                " St\xFCck</strong><br>" +
                bundleGroups(item)
                  .map(function (g) {
                    return (
                      esc2(g.color) +
                      " / " +
                      esc2(g.size) +
                      ": " +
                      g.qty +
                      " St\xFCck"
                    );
                  })
                  .join(" \xB7 ") +
                "</p>"
              );
            })
            .join("") +
          "<p><strong>Gesamt: " +
          bundle.items.reduce(function (n, item) {
            return n + bundleTotal(item);
          }, 0) +
          " St\xFCck</strong></p><p>Logo / Veredelung / Hinweise: ________________________________________________</p><p>Kontakt f\xFCr R\xFCckfragen: ______________________________________________________</p><p>Bitte an info@aloe-gmbh.de senden. Noch keine Bestellung; Verf\xFCgbarkeit und Ausf\xFChrung best\xE4tigen wir im Angebot.</p></body></html>",
        old = document.getElementById("aloe-team-print");
      old && old.remove();
      var frame = document.createElement("iframe");
      ((frame.id = "aloe-team-print"),
        (frame.title = "Druckansicht Team-Sammelliste"),
        (frame.style.cssText =
          "position:fixed;width:1px;height:1px;left:-10000px;border:0"),
        (frame.onload = function () {
          (frame.contentWindow.focus(), frame.contentWindow.print());
        }),
        (frame.srcdoc = html),
        document.body.appendChild(frame),
        status(
          "Die Sammelliste ist im Druckdialog ge\xF6ffnet. Dort kannst du sie als PDF sichern.",
        ));
    }
    function downloadBundle() {
      if (!bundle.items.length) {
        status(
          "Bitte zuerst mindestens einen Artikel zur Sammelliste hinzuf\xFCgen.",
        );
        return;
      }
      var clean = function (value) {
          return String(value || "").replace(/[\t\r\n]/g, " ");
        },
        content =
          "TEAM-SAMMELLISTE \u2013 ALOE TEXTIL\nVerein / Firma: " +
          clean(bundle.org) +
          "\n\n" +
          bundle.items
            .map(function (item, i) {
              return (
                i +
                1 +
                ". ARTIKEL: " +
                clean(item.title) +
                "\n" +
                location.origin +
                item.path +
                "\n" +
                item.rows
                  .map(function (r, j) {
                    return (
                      "  " +
                      (j + 1) +
                      ". " +
                      clean(r.name) +
                      " | Farbe: " +
                      clean(r.color) +
                      " | Gr\xF6\xDFe: " +
                      clean(r.size) +
                      " | St\xFCck: " +
                      r.qty
                    );
                  })
                  .join("\n") +
                "\nSumme: " +
                bundleTotal(item) +
                " St\xFCck"
              );
            })
            .join("\n\n") +
          "\n\nGESAMT: " +
          bundle.items.reduce(function (n, item) {
            return n + bundleTotal(item);
          }, 0) +
          " St\xFCck\n\nNoch keine Bestellung. Bitte zusammen mit Logo und Veredelungswunsch an info@aloe-gmbh.de senden.",
        url = URL.createObjectURL(
          new Blob(["\uFEFF" + content], { type: "text/plain;charset=utf-8" }),
        ),
        link = document.createElement("a");
      ((link.href = url),
        (link.download = "Aloe-Team-Sammelliste.txt"),
        link.click(),
        setTimeout(function () {
          URL.revokeObjectURL(url);
        }, 3e4),
        status(
          "Sammelliste heruntergeladen. Bitte zusammen mit deiner Anfrage senden.",
        ));
    }
    function addCurrentToBundle() {
      var complete = rows.filter(valid);
      if (
        !complete.length ||
        rows.some(function (r) {
          return used(r) && !valid(r);
        })
      )
        return (
          status(
            "Bitte mindestens eine vollst\xE4ndige Zeile eintragen und begonnene Zeilen vervollst\xE4ndigen.",
          ),
          !1
        );
      var item = {
          id: String(S.product.id),
          title: S.product.title,
          path: location.pathname,
          rows: complete.map(function (r) {
            return {
              name: r.name,
              color: r.color,
              size: r.size,
              qty: Number(r.qty),
            };
          }),
        },
        existingIndex = bundle.items.findIndex(function (saved) {
          return saved.id === item.id;
        });
      return existingIndex < 0 && bundle.items.length >= 20
        ? (status("Maximal 20 unterschiedliche Artikel pro Sammelliste."), !1)
        : (existingIndex >= 0
            ? (bundle.items[existingIndex] = item)
            : bundle.items.push(item),
          (bundle.org = dialog.querySelector("#team-org").value),
          saveBundle()
            ? (renderBundle(),
              status(
                "Artikel mit " +
                  bundleTotal(item) +
                  " St\xFCck \xFCbernommen. Du kannst jetzt ein weiteres Produkt ausw\xE4hlen.",
              ),
              !0)
            : !1);
    }
    (trigger.addEventListener("click", function () {
      loadBundle();
      var existing = bundle.items.find(function (item) {
        return item.id === String(S.product.id);
      });
      if (existing && !rows.length) {
        rows = existing.rows.map(function (r) {
          return {
            name: r.name,
            color: r.color,
            size: r.size,
            qty: String(r.qty),
          };
        });
        var existingColors = unique(
          rows.map(function (r) {
            return r.color;
          }),
        );
        ((teamColor =
          colors.indexOf(existingColors[0]) >= 0
            ? existingColors[0]
            : teamColor),
          (mixedColors = existingColors.length > 1));
      }
      if (
        (bundle.org &&
          !dialog.querySelector("#team-org").value &&
          (dialog.querySelector("#team-org").value = bundle.org),
        !rows.length)
      )
        for (var i = 0; i < 5; i++) add();
      (render(), dialog.showModal());
    }),
      dialog.addEventListener("change", function (event) {
        (event.target.id === "team-default-color" &&
          ((teamColor = event.target.value),
          mixedColors ||
            rows.forEach(function (row) {
              ((row.color = teamColor),
                sizes(teamColor).indexOf(row.size) < 0 && (row.size = ""));
            }),
          render(),
          status(
            teamColor
              ? "Teamfarbe ausgew\xE4hlt: " +
                  teamColor +
                  ". Jetzt Gr\xF6\xDFen und St\xFCckzahlen eintragen."
              : "Bitte zuerst eine Farbe w\xE4hlen.",
          )),
          event.target.id === "team-mixed-colors" &&
            ((mixedColors = event.target.checked),
            mixedColors ||
              rows.forEach(function (row) {
                ((row.color = teamColor),
                  sizes(teamColor).indexOf(row.size) < 0 && (row.size = ""));
              }),
            render(),
            status(
              mixedColors
                ? "Jetzt kannst du die Farbe je Person ausw\xE4hlen."
                : "Die Teamfarbe gilt jetzt f\xFCr alle Zeilen. Bitte Gr\xF6\xDFen pr\xFCfen.",
            )));
      }),
      dialog.addEventListener("input", function (event) {
        var field = event.target.dataset.field,
          tr = event.target.closest("[data-row]");
        if (!(!field || !tr)) {
          var row = rows[Number(tr.dataset.row)];
          ((row[field] = event.target.value),
            field === "color" &&
              (sizes(row.color).indexOf(row.size) < 0 && (row.size = ""),
              (tr.querySelector('[data-field="size"]').innerHTML = selected(
                sizes(row.color),
                row.size,
                "Gr\xF6\xDFe w\xE4hlen",
              ))),
            summary());
        }
      }),
      dialog.addEventListener("click", function (event) {
        var catalogLink = event.target.closest(
          'a[href="/collections/all"],a[href^="/products/"]',
        );
        if (catalogLink && rows.some(used) && !addCurrentToBundle()) {
          event.preventDefault();
          return;
        }
        var button = event.target.closest("button");
        if (button) {
          if (button.hasAttribute("data-remove")) {
            (rows.splice(Number(button.dataset.remove), 1), render());
            return;
          }
          if (button.hasAttribute("data-bundle-remove")) {
            var index = Number(button.dataset.bundleRemove);
            if (
              !bundle.items[index] ||
              !confirm("Diesen Artikel aus der Sammelliste entfernen?")
            )
              return;
            (bundle.items.splice(index, 1),
              saveBundle() &&
                (renderBundle(),
                status("Artikel aus der Sammelliste entfernt.")));
            return;
          }
          var action = button.dataset.team;
          if ((action === "close" && dialog.close(), action === "add")) {
            if (rows.length >= 200) {
              status("Maximal 200 Zeilen pro Liste.");
              return;
            }
            (add(), render());
          }
          if (action === "fifty") {
            for (; rows.length < 50; ) add();
            render();
          }
          if (action === "save")
            try {
              (localStorage.setItem(
                key,
                JSON.stringify({
                  rows: rows,
                  teamColor: teamColor,
                  mixedColors: mixedColors,
                  org: dialog.querySelector("#team-org").value,
                  productTitle: S.product.title,
                  productPath: location.pathname,
                  savedAt: Date.now(),
                }),
              ),
                status(
                  "Liste f\xFCr dieses Produkt auf diesem Ger\xE4t gespeichert.",
                ));
            } catch (e) {
              status(
                "Speichern nicht m\xF6glich. Bitte die Liste herunterladen oder als PDF sichern.",
              );
            }
          if (action === "load")
            try {
              var saved = JSON.parse(localStorage.getItem(key));
              if (!saved || !Array.isArray(saved.rows)) throw new Error();
              if (
                rows.some(used) &&
                !confirm(
                  "Aktuelle Eingaben durch die gespeicherte Liste ersetzen?",
                )
              )
                return;
              rows = saved.rows.slice(0, 200).map(function (r) {
                return {
                  name: String(r.name || "").slice(0, 80),
                  color: String(r.color || ""),
                  size: String(r.size || ""),
                  qty: String(r.qty || ""),
                };
              });
              var savedColors = unique(
                rows.map(function (r) {
                  return r.color;
                }),
              );
              ((teamColor =
                colors.indexOf(saved.teamColor) >= 0
                  ? saved.teamColor
                  : savedColors.length && colors.indexOf(savedColors[0]) >= 0
                    ? savedColors[0]
                    : teamColor),
                (mixedColors =
                  typeof saved.mixedColors == "boolean"
                    ? saved.mixedColors
                    : savedColors.length > 1),
                mixedColors ||
                  rows.forEach(function (r) {
                    ((r.color = teamColor),
                      sizes(teamColor).indexOf(r.size) < 0 && (r.size = ""));
                  }),
                (dialog.querySelector("#team-org").value = String(
                  saved.org || "",
                ).slice(0, 120)),
                render(),
                status(
                  "Liste geladen. Bitte Gr\xF6\xDFen und Farben erneut pr\xFCfen; das Sortiment kann sich ge\xE4ndert haben.",
                ));
            } catch (e) {
              status(
                "F\xFCr dieses Produkt ist keine lesbare Liste gespeichert.",
              );
            }
          if (
            action === "clear" &&
            confirm(
              "Liste und Speicherung f\xFCr dieses Produkt wirklich l\xF6schen?",
            )
          ) {
            try {
              localStorage.removeItem(key);
            } catch (e) {}
            ((rows = []),
              (mixedColors = !1),
              (teamColor =
                colors.indexOf(getCurrentPageColor()) >= 0
                  ? getCurrentPageColor()
                  : colors.length === 1
                    ? colors[0]
                    : ""),
              (dialog.querySelector("#team-org").value = ""));
            for (var j = 0; j < 5; j++) add();
            (render(), status("Liste gel\xF6scht."));
          }
          if (
            (action === "bundle-add" && addCurrentToBundle(),
            action === "bundle-print" && printBundle(),
            action === "bundle-download" && downloadBundle(),
            action === "bundle-clear" &&
              bundle.items.length &&
              confirm(
                "Die gesamte Sammelliste mit allen Artikeln auf diesem Ger\xE4t l\xF6schen?",
              ))
          )
            try {
              (localStorage.removeItem(bundleKey),
                (bundle = { org: "", items: [] }),
                renderBundle(),
                status("Sammelliste gel\xF6scht."));
            } catch (e) {
              status(
                "Sammelliste konnte nicht gel\xF6scht werden. Bitte Browser-Speicher pr\xFCfen.",
              );
            }
          if (
            ((action === "print" || action === "blank") &&
              print(action === "blank"),
            action === "download")
          ) {
            if (
              !rows.some(valid) ||
              rows.some(function (r) {
                return used(r) && !valid(r);
              })
            ) {
              status(
                "Bitte mindestens eine vollst\xE4ndige Zeile eintragen und begonnene Zeilen vervollst\xE4ndigen.",
              );
              return;
            }
            var clean = function (value) {
                return String(value || "").replace(/[\t\r\n]/g, " ");
              },
              text =
                "TEAM-BESTELLLISTE \u2013 ALOE TEXTIL\n" +
                S.product.title +
                "\n" +
                location.origin +
                location.pathname +
                "\nVerein / Firma: " +
                clean(dialog.querySelector("#team-org").value) +
                "\n\n" +
                rows
                  .filter(valid)
                  .map(function (r, i) {
                    return (
                      i +
                      1 +
                      ". Person: " +
                      clean(r.name) +
                      " | Farbe: " +
                      clean(r.color) +
                      " | Gr\xF6\xDFe: " +
                      clean(r.size) +
                      " | St\xFCck: " +
                      clean(r.qty)
                    );
                  })
                  .join("\n") +
                "\n\nMENGENZUSAMMENFASSUNG\n" +
                groups()
                  .map(function (g) {
                    return (
                      g.color + " / " + g.size + ": " + g.qty + " St\xFCck"
                    );
                  })
                  .join("\n") +
                "\n\nNoch keine Bestellung. Bitte zusammen mit Logo und Veredelungswunsch an info@aloe-gmbh.de senden.",
              url = URL.createObjectURL(
                new Blob(["\uFEFF" + text], {
                  type: "text/plain;charset=utf-8",
                }),
              ),
              link = document.createElement("a");
            ((link.href = url),
              (link.download =
                "Aloe-Team-Bestellliste-" + S.product.id + ".txt"),
              link.click(),
              setTimeout(function () {
                URL.revokeObjectURL(url);
              }, 3e4),
              status(
                "Textdatei heruntergeladen. Bitte zusammen mit deiner Anfrage senden.",
              ));
          }
        }
      }));
  }
  function init() {
    if (
      ((S.product = window.__aloeProduct || null),
      !(!S.product || !S.product.variants) &&
        S.product.handle !== "dtf-meterbogen-560x1000")
    ) {
      if (
        ((S.variants = S.product.variants || []),
        (S.mockupType = detectMockupType()),
        (S.hasFrontZipper = detectFrontZipper()),
        document.documentElement.dataset.aloeDesignerClickBound ||
          ((document.documentElement.dataset.aloeDesignerClickBound = "true"),
          document.addEventListener(
            "click",
            function (event) {
              var button = event.target.closest
                ? event.target.closest('#aloe-design-btn,[href="#aloe-designer-overlay"]')
                : null;
              button && (event.preventDefault(), openDesigner());
            },
            !0,
          )),
        readSwatchesFromDOM(),
        buildModal(),
        (S.selectedColor = getCurrentPageColor()),
        !S.selectedColor)
      ) {
        var initialColor = document.querySelector(".des-color[data-value]");
        initialColor && (S.selectedColor = initialColor.dataset.value);
      }
      document
        .querySelectorAll(".des-color[data-value]")
        .forEach(function (colorButton) {
          colorButton.classList.toggle(
            "active",
            colorButton.dataset.value === S.selectedColor,
          );
        });
      var initialColorLabel = document.getElementById("des-color-label");
      if (
        (initialColorLabel &&
          (initialColorLabel.textContent = displayColorName(
            S.selectedColor || "",
          )),
        S.mockupType
          ? renderMockup()
          : S.product.images &&
            S.product.images[0] &&
            setProductImage(S.product.images[0].src || S.product.images[0]),
        bindEvents(),
        bindEditorImprovements(),
        insertButton(),
        initTeamList(),
        location.hash === "#aloe-team-list")
      ) {
        var teamTrigger = document.querySelector(".aloe-team-trigger");
        teamTrigger &&
          (teamTrigger.click(),
          document.querySelector('#aloe-team-list [data-team="load"]').click());
      }
      UPSELL_FLOW.active &&
        window.setTimeout(function () {
          (openDesigner(), applyUpsellQuantity());
        }, 0);
      if (location.hash === "#aloe-designer-overlay") openDesigner();
    }
  }
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();
})();
